import React, { useEffect, useState, useContext, useRef } from 'react';
import { systemCode, xs_languageCode } from '../../.';
import { getLabel } from '../../data/labels';
import { ShopReceiptPrinterContext } from '../printer/ShopReceiptPrinterContext';
import { cashoutTicket } from '../purchase-service';
import { generateFrontendTransactionId, GENERATE_REST_VOUCHER_RETRY, getPendingFrontendTransactionId, removeFrontendTransactionId, retryCheckGenerateRestVoucher, saveFrontendTransactionId, ACCOUNT_RECHARGE_PHYSICAL_SELF_RETRY } from '../retry-service';
import { getBetAggr, getBetDesc, getConfiguration, getAmountInCent, normalizeNumber, isCoinAmount, getCurrencyValue, getCurrencySymbol, getNowTimestamp } from '../utils';
import { fetchSelfList } from './fetchSelfList';
import { fetchShopMonitorConfiguration } from './fetchShopMonitorConfiguration';
import { L_STORAGE_KEY_SHOW_PROFILE } from '../constants';
import { getEnv } from '../env';
import $ from 'jquery';

export const ShopContext = React.createContext(null);


// exposing window functions if there are not present, to allow the included product to work with the shop flow
if(!window.getVoucherParamsFromLS){
	window.getVoucherParamsFromLS = function (){
		return JSON.parse(localStorage.getItem("current_voucher"));
	}
}

if(!window.setVoucherParametersOnLS){
	window.setVoucherParametersOnLS = function(voucher){
		if(voucher != null){
			localStorage.setItem("current_voucher", JSON.stringify(voucher));		
		}
	}
}

if(!window.removeVoucherParametersOnLS){
	window.removeVoucherParametersOnLS = function(){
		localStorage.removeItem("current_voucher");
	}
}

if(!window.getLoggedParamsFromLS){
	window.getLoggedParamsFromLS = function (){
		let logP = localStorage.getItem("operator_logged_parameters");
		if(logP != null){
			return JSON.parse(logP);			
		}
		return null;
	}
}

if(!window.setLoggedParametersOnLS){
	window.setLoggedParametersOnLS = function(operator){
		localStorage.setItem("operator_logged_parameters", JSON.stringify(operator));
	}
}


if(!window.removeLoggedParametersOnLS){
	window.removeLoggedParametersOnLS = function(){
		localStorage.removeItem("operator_logged_parameters");
	}
}

if(!window.getCustomerBalanceFromLS){
	window.getCustomerBalanceFromLS = function() {
		const lp = window.getLoggedParamsFromLS();
		if(lp){
			return lp.userBalance;
		}
		return 0;	
	}

}


function ShopConf(props) {
	const shopReceiptPrinterContext = useContext(ShopReceiptPrinterContext);
	const conf = getConfiguration();
	const retailConf = conf.rs;
	const selfContext = props.selfContext || {}; // under xshop app, this will be valued
	
	// function mustBePrintedBySocket(template){
	// 	if(selfContext.mustBePrintedBySocket){
	// 		return selfContext.mustBePrintedBySocket(template);
	// 	}
	// 	return false;
	// }
	const [shopContext, setShopContext] = useState({
		enabled : window.appConfig.SHOP_MODE,
		operator : null,
		selfCashier : null,
		shopBooker : null,
		cfForPurchase : null,
		type : null,
		skinProperties : null,
		isAppApkOldSport : window.isTerminalMobileApp && window.isTerminalMobileApp(),
		useXSportDatastoreApi : props.useSocket,
		userState : null,
		isSlaveOfAnotherShopConf : getEnv('REACT_APP_IS_SHOP_SLAVE'),
		operationStatusMessage : {showed : false, type : null, desc : null},
		ticketModalOpened:useRef(false),
		busy : false,
		balanceUpdateTimeoutRef : null,
		shopTotalBalance : 0,
		containerMonitorConfigurationData : null,
		monitorConfigurationDataToBeSaved : false,
		selfListContainer : null,
		terminalBalancePollingId : null,
		ticketHeldInScanner: false,
		hookAllKeystrokesOnPurchase: selfContext?.hookAllKeystrokesOnPurchase,
	    update : function(updt) {
			// updating temporary
			for(let ko in updt){
				const val = updt[ko];
				ctxs.shopContext[ko] = val;
			}
			//update effectly
			setShopContext(prev => {
                return {...prev, ...updt};
            });
        },

		isHookAllKeystrokesOnPurchaseEnabled : function() {
			if(ctxs.shopContext.isSlaveOfAnotherShopConf){
				return window.shopApi.isHookAllKeystrokesOnPurchaseEnabled();
			}else{
				return ctxs.shopContext?.hookAllKeystrokesOnPurchase;
			}
		},
		
		setTerminalBalancePolling : function(activate){
			if(ctxs.shopContext.isSlaveOfAnotherShopConf){
				return;
			}
			if(activate){
				if(!ctxs.shopContext.terminalBalancePollingId){
					const interval = window.setInterval(function(){
						ctxs.shopContext.reloadShopUser();
					}, 5000);
					ctxs.shopContext.update({terminalBalancePollingId: interval})				
				}
			}
			else {
				if(ctxs.shopContext.terminalBalancePollingId){
					window.clearInterval(ctxs.shopContext.terminalBalancePollingId);				
					ctxs.shopContext.update({terminalBalancePollingId: null});
				}
			}
		},
		
		setRefreshXTokenSessionPolling(activate){
			if(ctxs.shopContext.isSlaveOfAnotherShopConf){
				return;
			}
			if(activate){
				if(!ctxs.shopContext.refreshXTokenSessionIntervalId){
					const url = getConfiguration().api['shop.keepAliveXTokenSession'];
					const params = {
						systemCode : systemCode,
						lingua: xs_languageCode,
						hash: '',
						sessionToken : ctxs.shopContext.operator?.sessionToken			
			    	};
					const interval = window.setInterval(function(){
						$.ajax({
				    		type: "POST",
				    		url : url,
				    		data: params,
				    		async : true,
				    		success : () => {},
				    		error : (errorData, textStatus, errorThrown) => {
								console.error("Error in calling keepAliveXTokenSession " + textStatus + " " + errorThrown);
				    		}	
			       		});
					}, 60000);
					ctxs.shopContext.update({refreshXTokenSessionIntervalId: interval})				
				}
			}
			else {
				if(ctxs.shopContext.refreshXTokenSessionIntervalId){
					window.clearInterval(ctxs.shopContext.refreshXTokenSessionIntervalId);				
					ctxs.shopContext.update({refreshXTokenSessionIntervalId: null});
				}
			}		
		},
		
		setSelfListContainer : function(selfListContainer){
			setShopContext(function(prev){
				return {
					...prev,
					selfListContainer
				}
			});
		},
		
		fetchSelfList : function(){
			ctxs.shopContext.setSelfListContainer({isLoading:true, isError: false, data : null});
			fetchSelfList(ctxs.shopContext.operator.sessionToken, function(response){
				ctxs.shopContext.setSelfListContainer({isLoading:false, isError: false, data : response});
			}, () => {
				ctxs.shopContext.setSelfListContainer({isLoading:false, isError: true, data : null});
			});
		},
		
		fetchMonitorConfigurationData : function(){
			ctxs.shopContext.setContainerMonitorConfigurationData({isLoading:true, isError: false, data : null});
			fetchShopMonitorConfiguration(ctxs.shopContext.operator.sessionToken, function(response){
				ctxs.shopContext.setContainerMonitorConfigurationData({isLoading:false, isError: false, data : response});
			}, () => {
				ctxs.shopContext.setContainerMonitorConfigurationData({isLoading:false, isError: true, data : null});
			});
		},
		
		setContainerMonitorConfigurationData: function (containerMonitorConfigurationData){
			setShopContext(function(prev){
				return {
					...prev,
					containerMonitorConfigurationData
				}
			});
		},
		
		updateMonitorConfigurationData: function (monitorConfigurationData){
			const containerMonitorConfigurationData = ctxs.shopContext.containerMonitorConfigurationData;
			containerMonitorConfigurationData.data = monitorConfigurationData;
			setShopContext(function(prev){
				return {
					...prev,
					containerMonitorConfigurationData,
					monitorConfigurationDataToBeSaved : true
				}
			});
		},
		
		editShopMonitorConfiguration(operationData){
			const data = ctxs.shopContext.containerMonitorConfigurationData.data;
			if(operationData.operation === 'addConfiguration'){
				data.pageList.push({
					id : data.pageList.length + 1,
					tls : [],
					sps: [],
					type : '-',
					row: 16,
					dly:0
				});
			}
			else if(operationData.operation === 'removeConfiguration'){
				const pageList = [];
				for(let k in data.pageList){
					if(data.pageList[k].id !== operationData.page.id){
						pageList.push(data.pageList[k]);
					}
				}
				for(let k in pageList){
					pageList[k].id = parseInt(k) + 1;
				}
				data.pageList = pageList;
			
			}
			setShopContext(function(prev){
				return {
					...prev,
					containerMonitorConfigurationData : {isLoading:false, isError: false, data : data},
					monitorConfigurationDataToBeSaved : true
				}
			});
		},
		
		saveMonitorConfigurationData : function(){
			if(ctxs.shopContext.busy){
				return;
			}
			ctxs.shopContext.setOperationStatusMessage(false, null, null);
			ctxs.shopContext.setBusy();
			const pageListEdited = ctxs.shopContext.containerMonitorConfigurationData.data.pageList;
			// restore data
			const pageList = [];
			for(let kp in pageListEdited){
				const page = pageListEdited[kp];
				if(page.type === 'PREMATCH'){
					if(page.tls && page.tls.length > 0){
						delete page.sps;
						pageList.push(page);
					}
				}
				else if(page.type === 'LIVE'){
					delete page.tls;
					if(page.sps && page.sps.length == 0){
						page.sps = null; // all sports
					}
					pageList.push(page);
				}
			}
			// refreshing the IDS
			for(let kp in pageList){
				pageList[kp].id = parseInt(kp) + 1;
			}
			const params = {
				systemCode : systemCode,
				lingua: xs_languageCode,
				hash: '',
				sessionToken : ctxs.shopContext.operator.sessionToken			
	    	};
	    	const url = getConfiguration().api['shop.saveMonitorConfigurationData'];
			$.ajax({
	    		type: "POST",
	    		url : url + "?" +  $.param(params),
	    		data: window.encodeURI(JSON.stringify(pageList)),
        		dataType: 'json',
        		contentType: "application/json; charset=UTF-8;",
	    		async : true,
	    		success : (resultContainer) => {
	    			ctxs.shopContext.setFree();
	    			if(resultContainer != null){
	    				if(resultContainer.code == 0){
	    					const monitorConfigurationData = ctxs.shopContext.containerMonitorConfigurationData.data;
	    					monitorConfigurationData.pageList = pageList;
							setShopContext(function(prev){
								return {
									...prev,
									containerMonitorConfigurationData : {isLoading:false, isError: false, data : monitorConfigurationData},
									monitorConfigurationDataToBeSaved : false
								}
							});
							ctxs.shopContext.setOperationStatusMessage(true, 'success', getLabel('generic.save_ok'));
							
							setTimeout(() => {
								ctxs.shopContext.setOperationStatusMessage(false, null, null);
							}, 1500);
	    				}
	    				else {
	    					ctxs.shopContext.setOperationStatusMessage(true, 'error', resultContainer.code + " - " + resultContainer.description);
	    				}
	    			}
	    			else{
	    				ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error.');
	    			}
	    		},
	    		error : (errorData) => {
	    			ctxs.shopContext.setFree();
	    			ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error.');
	    		}	
		    });	
		},
				
		buildSkinProperties : function(){
			let skinProperties = null;
			if (window.CUSTOMERS) {
				skinProperties = window.CUSTOMERS.get(window.SYSTEM_CODE);
				if (skinProperties) {
					skinProperties = skinProperties.terminalSettingsDTO;
				}
			} else {
				skinProperties = {
                    functions: retailConf?.fce,
                    hideTerminalTicket: retailConf.otid,
                    cnPrenotatore : retailConf.cnb,
                    pvendPrenotatore: retailConf.pvb
				};
			}
			skinProperties = skinProperties? skinProperties : {};
			setShopContext(function(prev){
				return {
					...prev,
					skinProperties
				}
			});
		},
		
		initType : function (){
			const type = getType();
			ctxs.shopContext.type = type;
			setShopContext(function(prev){
				return {
					...prev,
					type : type
				}
			});
		},
		
		setBusy : function (bypassShadow){
			if(ctxs.shopContext.isSlaveOfAnotherShopConf){
				window.shopApi.setDeviceBusy();
			}	
			else{
				if(window.XSocket){
					window.XSocket.setBusyApp();
				}
			}
			if(!bypassShadow){
				addBodyShadow();				
			}
			//ctxs.shopContext.setTerminalBalancePolling(false);
			ctxs.shopContext.update({busy: true});
		},
		
		setFree : function(){
			removeBodyShadow();
			if(ctxs.shopContext.isSlaveOfAnotherShopConf){
				window.shopApi.setDeviceFree();
			}
			else{
				if(window.XSocket){
					window.XSocket.setFreeApp();
				}
			}
			ctxs.shopContext.update({busy: false});
		},
		
		setUserState : function(newState){
			ctxs.shopContext.userState = newState;
			setShopContext(function(prev){
				return {
					...prev,
					userState : newState
				}
			});
		},

		setTicketModalOpened(opened){
			ctxs.shopContext.ticketModalOpened.current = opened;
		},
		
		getCustomerBalance : function (){
			if(ctxs.shopContext.operator){
				return ctxs.shopContext.operator.userBalance;
			}
			return 0;
		},
		
		increaseCustomerBalance : function (amount){
			if(window.incrementaSaldoClienteLS){
				// we are under the old XSport Terminal
				window.incrementaSaldoClienteLS(amount);				
			}
			else {
				if(ctxs.shopContext.isSlaveOfAnotherShopConf){
					// triggering the main one
					window.shopApi.increaseCustomerBalance(amount);
				}
				else{
					// trigger this one
					ctxs.shopContext.setCustomerBalance(ctxs.shopContext.getCustomerBalance() + amount)					
				}
			}
		},
		decreaseCustomerBalance : function(amount){
			if(ctxs.shopContext.isSlaveOfAnotherShopConf){
				// triggering the main one
				window.shopApi.decreaseCustomerBalance(amount);
			}
			else{
				// trigger this one
				let newAmount = ctxs.shopContext.getCustomerBalance() - amount;
				//newAmount = newAmount < 0? 0 : newAmount;
				ctxs.shopContext.setCustomerBalance(newAmount);			
			}
		},
		
		showMonitorMessage : function (message, permanent){
			if(ctxs.shopContext.isSlaveOfAnotherShopConf){
				// triggering the main one
				window.shopApi.showMonitorMessage(message);
			}
			else{
				if(selfContext && selfContext.freezeAllPermanent){
					if(permanent && selfContext.freezeAllPermanent){
						selfContext.freezeAllPermanent(message);
					}
					if(!permanent && selfContext.freezeAll){
						selfContext.freezeAll(message);
					}
				}
			}
		},
		
		removeMonitorMessage : function (){
			if(ctxs.shopContext.isSlaveOfAnotherShopConf){
				// triggering the main one
				window.shopApi.removeMonitorMessage();
			}
			if(selfContext && selfContext.unfreezeAll){
				selfContext.unfreezeAll();
			}
		},
		
		setTerminalBalance : function (newBalance){
			if(ctxs.shopContext.isSlaveOfAnotherShopConf){
				// triggering the main one
				window.shopApi.setTerminalBalance(newBalance);
			}
			else{
				// trigger this one
				if(ctxs.shopContext.operator){
					const operator = ctxs.shopContext.operator;
					operator.terminalBalance = newBalance;
					window.setLoggedParametersOnLS(operator);
					ctxs.shopContext.setShopUser(operator);
				}			
			}
		},
		
		increaseTerminalBalance : function(amount){
			if(ctxs.shopContext.isSlaveOfAnotherShopConf){
				// triggering the main one
				window.shopApi.increaseTerminalBalance(amount);
			}
			else{
				// trigger this one
				if(ctxs.shopContext.operator){
					const operator = ctxs.shopContext.operator;
					const newBalance = operator.terminalBalance + amount;
					operator.terminalBalance = newBalance;
					window.setLoggedParametersOnLS(operator);
					ctxs.shopContext.setShopUser(operator);
					console.debug("SALDO CASSA AGGIORNATO! " + operator.terminalBalance);
				}			
			}		
		},
		
		setCustomerBalance : function(amount){	
			console.debug("setCustomerBalance "+amount);
			if(ctxs.shopContext.isSlaveOfAnotherShopConf){
				// triggering the main one
				window.shopApi.setCustomerBalance(amount);
			}
			else{
				// trigger this one
				if(ctxs.shopContext.operator){
					const operator = ctxs.shopContext.operator;
					operator.userBalance = amount;
					window.setLoggedParametersOnLS(operator);
					ctxs.shopContext.setShopUser(operator);
				}else{
					console.error("setCustomerBalance: operator is "+ctxs?.shopContext?.operator)
				}	
			}
		},
		
		setOperationStatusMessage(showed, type, desc){
			const os = {
					showed,
					type,
					desc
			};
			ctxs.shopContext.operationStatusMessage = os;
			setShopContext(function(prev){
				return {
					...prev,
					operationStatusMessage : os
				}
			});	
			if(selfContext?.showModalMessage && props.apkPosLite){
				selfContext.showModalMessage(desc, type, false, false, null);
			}
		},
		
		hideOperationStatusMessage(){
			ctxs.shopContext.setOperationStatusMessage(false, null, null);
			if(selfContext?.hideModalMessage && props.apkPosLite){
				selfContext.hideModalMessage();
			}
		},
		
		loginOperator : function(username, password){
			if(ctxs.shopContext.busy){
				return;
			}
			
			ctxs.shopContext.hideOperationStatusMessage();
			if(ctxs.shopContext.operator == null || ctxs.shopContext.operator.logged == false){
				ctxs.shopContext.setBusy();
				const url = getConfiguration().api['shop.loginOperator'];
	  			const params = {
    					systemCode : systemCode,
    					lingua: xs_languageCode,
    					hash: '',
    					username : username,
    					password : password
    			}
	  			if(ctxs.shopContext.useXSportDatastoreApi || props.apkPosLite){
	  				params.idTag =  selfContext.idTag != null? selfContext.idTag : selfContext.appData?.idTag;
	  				params.idPvend = selfContext.idPvend != null?  selfContext.idPvend : selfContext.appData?.idPvend;
	  				if(params.idTag == null || params.idTag == null){
	  					ctxs.shopContext.setShopUser({logged : false, operator : true, selfCashier : false});
		    			ctxs.shopContext.setOperationStatusMessage(true, 'error', getLabel('carrello.error.user_not_logged') + ' - [pvend-idtag issue]');
	  					return;
	  				}
	  			}
		    	$.ajax({
		    		type: "POST",
		    		url : url,
		    		data: params,
		    		async : true,
		    		success : (data) => {
		    			ctxs.shopContext.setFree();
		    			if(data != null){
		    				const operatorContainer = JSON.parse(data);
		    				if(operatorContainer.code == 0){
			    				const operator = operatorContainer.object;
			    				operator.operator = true;
			    				operator.selfCashier = false;
			    				operator.userBalance = window.getCustomerBalanceFromLS();
			    				window.setLoggedParametersOnLS(operator);
			    				ctxs.shopContext.setShopUser(operator);
			    				if(window.shopApiSlave != null){
			    					window.shopApiSlave.reloadShopUser();
			    				}
		    				}
		    				else {
				    			ctxs.shopContext.setShopUser({logged : false, operator : true, selfCashier : false});
		    					ctxs.shopContext.setOperationStatusMessage(true, 'error', operatorContainer.code + " - " + operatorContainer.description);
		    				}
		    			}
		    			else{
		    				ctxs.shopContext.setShopUser({logged : false, operator : true, selfCashier : false});
		    				ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error.');
		    			}
		    		},
		    		error : (errorData) => {
		    			ctxs.shopContext.setFree();
		    			ctxs.shopContext.setShopUser({logged : false, operator : true, selfCashier : false});
		    			ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error.');
		    		}	
		       });	
			}
		},
		
		isFunctionalityAllowed(functionality){
			if(ctxs.shopContext.skinProperties?.functions?.[functionality] != null){
				if(ctxs.shopContext.operator){
					if(functionality === window.retailFunctions['PAY_TICKET']){
						return ctxs.shopContext.operator.payTicketEnabled;
					}
					if(functionality === window.retailFunctions['CANCEL_TICKET']){
						return ctxs.shopContext.operator.discardTicketEnabled;
					}
					if(functionality === window.retailFunctions['RETURN_CASH']){
						return ctxs.shopContext.operator.returnCashEnabled;
					}
					if(functionality === window.retailFunctions['PHYSICAL_SELF_VOUCHER_CREATION'] || functionality === window.retailFunctions['PHYSICAL_SELF_VOUCHER_PAYMENT'] || functionality === window.retailFunctions['WORKING_SELF_LIST']){
						return ctxs.shopContext.operator.voucherEnabled;
					}
				}
				return true;
			}
			return false;
		},
		
		logoutOperator : function(successCallback){
			if(ctxs.shopContext.busy){
				return;
			}
			if(ctxs.shopContext.operator && ctxs.shopContext.operator.logged){
				ctxs.shopContext.setBusy();
				const url = getConfiguration().api['shop.logoutOperator'];
	  			const params = {
    					systemCode : systemCode,
    					lingua: xs_languageCode,
    					hash: '',
    					sessionToken : ctxs.shopContext.operator.sessionToken
    			}
	  			
		    	$.ajax({
		    		type: "POST",
		    		url : url,
		    		data: params,
		    		async : true,
		    		success : (data) => {
		    			ctxs.shopContext.setFree();
		    			if(data != null){
		    				const operatorContainer = JSON.parse(data);
		    				if(operatorContainer.code == 0){
		    					window.removeLoggedParametersOnLS();
								localStorage.removeItem(L_STORAGE_KEY_SHOW_PROFILE);
				    			ctxs.shopContext.setShopUser({logged : false, operator : true, selfCashier : false});
			    				if(window.shopApiSlave != null){
			    					window.shopApiSlave.reloadShopUser();
			    				}
								if(successCallback){
									successCallback();
								}
		    				}
		    				else {
		    					ctxs.shopContext.setOperationStatusMessage(true, 'error', operatorContainer.code + " - " + operatorContainer.description);
		    				}
		    			}
		    			else{
		    				ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error.');
		    			}
		    		},
		    		error : (errorData) => {
		    			ctxs.shopContext.setFree();
		    			ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error.');
		    		}	
		       });	
			}else{
				if(successCallback){
					successCallback();
				}
			}
		},
		
		newCustomer : function (){
			if(ctxs.shopContext.busy){
				return;
			}
			if(!ctxs.shopContext.isFunctionalityAllowed(window.retailFunctions['NEW_CLIENT'])){
				return;
			}
			ctxs.shopContext.setCustomerBalance(0);
		},
		
		grantCash : function(amount){
			if(ctxs.shopContext.busy){
				return;
			}
			if(!ctxs.shopContext.isFunctionalityAllowed(window.retailFunctions['GRANT_CASH'])){
				return;
			}
			
			function action(){
				ctxs.shopContext.hideOperationStatusMessage();
				if(ctxs.shopContext.operator && ctxs.shopContext.operator.logged){
					ctxs.shopContext.setBusy();
					const amountCent = getAmountInCent(normalizeNumber(amount), conf.cs.m);
					if(amountCent == 0){
						return;
					}
		  			const params = {
						systemCode : systemCode,
						lingua: xs_languageCode,
						hash: '',
						sessionToken : ctxs.shopContext.operator.sessionToken,
						amount : amountCent
	    			};
					$.ajax({
			    		type: "POST",
			    		url : getConfiguration().api['shop.grantCash'],
			    		data: params,
			    		async : true,
			    		success : (data) => {
			    			ctxs.shopContext.setFree();
			    			if(data != null){
			    				const result = JSON.parse(data);
			    				if(result.code == 0){
			    					const operator = result.object;
			    					operator.userBalance = window.getCustomerBalanceFromLS();
				    				window.setLoggedParametersOnLS(operator);
				    				ctxs.shopContext.setShopUser(operator);
				    				result.operationAmount = amountCent;
				    				shopReceiptPrinterContext.printGrantCashReceipt(result);
			    				}
			    				else {
			    					ctxs.shopContext.setOperationStatusMessage(true, 'error', result.code + " - " + result.description);
			    					if(result.code == -5307){
			    						window.removeLoggedParametersOnLS();
			    						ctxs.shopContext.setShopUser({logged : false, operator : true, selfCashier : false});
			    						setTimeout(() => {
			    							window.location.reload();
			    						}, 1000);
						    			
			    					}
			    				}
			    			}
			    			else{
			    				ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error.');
			    			}
			    		},
			    		error : (errorData) => {
			    			ctxs.shopContext.setFree();
			    			ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error.');
			    		}	
			       });	
				}
			}
			
			
			const configuration = getConfiguration();
			const askForPaper = configuration.rs && configuration.rs.cfp && window.XSocket;
			if(!askForPaper){
				action();
			}
			else{
				ctxs.shopContext.setBusy();
				window.XSocket.askForPaper('GRANT_CASH', (data) => {
					if(data.body === 'OK'){
						selfContext.setPaperCaseEmpty(false);
						ctxs.shopContext.setFree();
						action();		  
					}
					else {
						ctxs.shopContext.setFree();
						selfContext.setPaperCaseEmpty(true, data.body);
					}
			    });
			}
			
		},
			
		returnCash : function(amount){
			if(ctxs.shopContext.busy){
				return;
			}
			if(!ctxs.shopContext.isFunctionalityAllowed(window.retailFunctions['RETURN_CASH'])){
				return;
			}
			
			
			function action(){
				ctxs.shopContext.hideOperationStatusMessage();
				if(ctxs.shopContext.operator && ctxs.shopContext.operator.logged){
					ctxs.shopContext.setBusy();
					const amountCent = getAmountInCent(normalizeNumber(amount), conf.cs.m);
					if(amountCent == 0){
						return;
					}

		  			const params = {
						systemCode : systemCode,
						lingua: xs_languageCode,
						hash: '',
						sessionToken : ctxs.shopContext.operator.sessionToken,
						amount : amountCent
	    			};
					$.ajax({
			    		type: "POST",
			    		url : getConfiguration().api['shop.returnCash'],
			    		data: params,
			    		async : true,
			    		success : (data) => {
			    			ctxs.shopContext.setFree();
			    			if(data != null){
			    				const result = JSON.parse(data);
			    				if(result.code == 0){
			    					const operator = result.object;
			    					operator.userBalance = window.getCustomerBalanceFromLS();
				    				window.setLoggedParametersOnLS(operator);
				    				ctxs.shopContext.setShopUser(operator);
				    				result.operationAmount = amountCent;
				    				shopReceiptPrinterContext.printReturnCashReceipt(result);
			    				}
			    				else {
			    					ctxs.shopContext.setOperationStatusMessage(true, 'error', result.code + " - " + result.description);
			    					if(result.code == -5307){
			    						window.removeLoggedParametersOnLS();
			    						ctxs.shopContext.setShopUser({logged : false, operator : true, selfCashier : false});
			    						setTimeout(() => {
			    							window.location.reload();
			    						}, 1000);
						    			
			    					}
			    				}
			    			}
			    			else{
			    				ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error.');
			    			}
			    		},
			    		error : (errorData) => {
			    			ctxs.shopContext.setFree();
			    			ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error.');
			    		}	
			       });	
				}
			}
			
			const configuration = getConfiguration();
			const askForPaper = configuration.rs && configuration.rs.cfp && window.XSocket;
			if(!askForPaper){
				action();
			}
			else{
				ctxs.shopContext.setBusy();
				window.XSocket.askForPaper('RETURN_CASH', (data) => {
					if(data.body === 'OK'){
						selfContext.setPaperCaseEmpty(false);
						ctxs.shopContext.setFree();
						action();		  
					}
					else {
						ctxs.shopContext.setFree();
						selfContext.setPaperCaseEmpty(true, data.body);
					}
			    });
			}
			
		},

		ticketHistory : function (dateFrom, dateTo, callback){
			if(ctxs.shopContext.busy){
				return;
			}
			if(!ctxs.shopContext.isFunctionalityAllowed(window.retailFunctions['TICKET_HISTORY'])){
				return;
			}
			ctxs.shopContext.hideOperationStatusMessage();
			if(ctxs.shopContext.operator && ctxs.shopContext.operator.logged){
				ctxs.shopContext.setBusy();
	  			const params = {
					systemCode : systemCode,
					lingua: xs_languageCode,
					hash: '',
					sessionToken : ctxs.shopContext.operator.sessionToken,
					dateFrom,
					dateTo
    			};
				$.ajax({
		    		type: "POST",
		    		url : getConfiguration().api['shop.getTicketHistory'],
		    		data: params,
		    		async : true,
		    		success : (data) => {
		    			ctxs.shopContext.setFree();
		    			if(data != null){
		    				const result = JSON.parse(data);
		    				if(result.code == 0){
		    					callback(result.object);
		    				}
		    				else {
		    					if(result.code == -5307){
		    						window.removeLoggedParametersOnLS();
		    						ctxs.shopContext.setShopUser({logged : false, operator : true, selfCashier : false});
		    						window.location.reload();	
		    					}
		    					else{
		    						callback([]);	
		    					}
		    				}
		    			}
		    			else{
		    				callback([]);
		    			}
		    		},
		    		error : (errorData) => {
		    			ctxs.shopContext.setFree();
		    			callback([]);
		    		}	
		       });	
			}
		},
		
		payTicket : function(ticketId, callback, errorCallback){
			if(ctxs.shopContext.busy){
				return;
			}
			if(!ctxs.shopContext.isFunctionalityAllowed(window.retailFunctions['PAY_TICKET'])){
				return;
			}
			function action(){
				ctxs.shopContext.hideOperationStatusMessage();
				if(ctxs.shopContext.operator && ctxs.shopContext.operator.logged){
					ctxs.shopContext.setBusy();
		  			const params = {
						systemCode : systemCode,
						lingua: xs_languageCode,
						hash: '',
						sessionToken : ctxs.shopContext.operator.sessionToken,
						ticketId : ticketId,
						identityPlayer : ctxs.shopContext.cfForPurchase
	    			};
					$.ajax({
			    		type: "POST",
			    		url : getConfiguration().api['shop.payTicket'],
			    		data: params,
			    		async : true,
			    		success : (data) => {
			    			ctxs.shopContext.setFree();
			    			ctxs.shopContext.setCfForPurchase(null);
			    			if(data != null){
								console.debug("SUCCESS payTicket [" + ticketId + "] got a response");
								console.debug("payTicket [" + ticketId + "] response ["+data+"]");
			    				const result = JSON.parse(data);
			    				if(result.code == 0 || (result.object && result.object.promotions && result.object.promotions.length > 0)){
			    					ctxs.shopContext.decreaseCustomerBalance(result.object.amount);
			    					ctxs.shopContext.setTerminalBalance(result.object.terminalBalance);
			    					// print receipt
			    					result.showOperatorName = !ctxs.shopContext.isFunctionalityAllowed(window.retailFunctions['HIDE_OPERATOR_ON_RECEIPT']);
			    					result.showTerminalBalance = !ctxs.shopContext.isFunctionalityAllowed(window.retailFunctions['HIDE_CASH_BALANCE_ON_RECEIPT']);
			    					shopReceiptPrinterContext.printPaymentTicketReceipt(result, false);
			    					if(callback){
			    						callback();
			    					}
			    				}
			    				else {
			    					if(result.code == -5307){
			    						
			    						window.removeLoggedParametersOnLS();
			    						ctxs.shopContext.setShopUser({logged : false, operator : true, selfCashier : false});
			    						window.location.reload();	
			    					}
			    					else if(result.code == -5281){
				    					ctxs.shopContext.showCfPopup(() => {
				    						ctxs.shopContext.payTicket(ticketId, callback);
				    					});
			    					}
			    					else if(result.code == -5529){
				    					selfContext.showDocumentIdModal((documentId) => {
				    						ctxs.shopContext.reserveDepositForFinalUser(ticketId, documentId, result.object.prot, result.object.amount, result.object.epsvd);
				    					});
			    					}
			    					else{
			    						ctxs.shopContext.setOperationStatusMessage(true, 'error', result.code + " - [" + ticketId + "] " + result.description);
			    						if(errorCallback){
			    							errorCallback(result);
			    						}
			    					}
			    				}
								payTicketBroadcastToSecondScreen(ticketId,result);
			    			}
			    			else{
								console.error("ERROR payTicket [" + ticketId + "] ha ricevuto risposta null");
			    				ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error');
			    				if(errorCallback){
			    					errorCallback({code : -1, description : 'Generic Error'});
			    				}
			    			}
			    		},
			    		error : (errorData, textStatus, errorThrown) => {
							console.error("Error in calling payTicket "+textStatus+" "+errorThrown);
							console.debug(errorData);
			    			ctxs.shopContext.setCfForPurchase(null);
			    			ctxs.shopContext.setFree();
			    			ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error');
			    			if(errorCallback){
			    				errorCallback({code : -1, description : 'Generic Error'});
			    			}
			    		}	
			       });	
				}
			}
			
			const configuration = getConfiguration();
			const askForPaper = configuration.rs && configuration.rs.cfp && window.XSocket;
			if(!askForPaper){
				action();
			}
			else{
				ctxs.shopContext.setBusy();
				window.XSocket.askForPaper('PAY_TICKET', (data) => {
					if(data.body === 'OK'){
						selfContext.setPaperCaseEmpty(false);
						ctxs.shopContext.setFree();
						action();		  
					}
					else {
						ctxs.shopContext.setFree();
						ctxs.shopContext.setCfForPurchase(null);
						selfContext.setPaperCaseEmpty(true, data.body);
					}
			    });
			}
		},

		payTicketRefillingSelf: function(ticketId, callback, errorCallback){
			if(ctxs.shopContext.busy || !conf.rs?.paysc){
				if(errorCallback){
					errorCallback();
				}
				return;
			}
			function action(){
				ctxs.shopContext.hideOperationStatusMessage();
				if(ctxs.shopContext.selfCashier && ctxs.shopContext.selfCashier.logged && !ctxs.shopContext.busy){
					ctxs.shopContext.setBusy();
		  			const params = {
						systemCode : systemCode,
						lingua: xs_languageCode,
						hash: '',
						sessionToken : ctxs.shopContext?.selfCashier?.sessionToken,
						ticketId : ticketId
	    			};
					$.ajax({
						type: "POST",
			    		url : getConfiguration().api['shop.payTicketRefillingSelf'],
			    		data: params,
			    		async : true,
						success : (data) => {
							ctxs.shopContext.setFree();
			    			ctxs.shopContext.setCfForPurchase(null);
							if(data != null){
								console.debug("SUCCESS payTicketRefillingSelf [" + ticketId + "] got a response");
								console.debug("payTicketRefillingSelf [" + ticketId + "] response ["+data+"]");
			    				const result = JSON.parse(data);
								if(result.code == 0){
									ctxs.shopContext.handleSelfCashierBalanceUpdate(null, () => {});
									if(callback){
			    						callback();
			    					}
								}
								else {
			    					if(result.code == -5307){
			    						window.removeLoggedParametersOnLS();
			    						ctxs.shopContext.setShopUser({logged : false, operator : false, selfCashier : true});
										if(errorCallback){
			    							errorCallback(result);
			    						}
										setTimeout(() => {
											window.location.reload();	
										}, 500);
			    						
			    					}
			    					else{
			    						if(errorCallback){
			    							errorCallback(result);
			    						}
			    					}
			    				}
							}
							else{
								console.error("ERROR payTicketRefillingSelf [" + ticketId + "] ha ricevuto risposta null");
			    				ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error');
			    				if(errorCallback){
			    					errorCallback({code : -1, description : 'Generic Error'});
			    				}
			    			}
						},
						error : (errorData, textStatus, errorThrown) => {
							console.error("Error in calling payTicketRefillingSelf "+textStatus+" "+errorThrown);
							console.debug(errorData);
			    			ctxs.shopContext.setFree();
			    			ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error');
			    			if(errorCallback){
			    				errorCallback({code : -1, description : 'Generic Error'});
			    			}
			    		}	
					});	
				}
			}
			try {
				action();
			}catch(err) {
				console.error(err);
				if(errorCallback){
					errorCallback();
				}
			}
		},
		
		cancelTicket : function (ticketId, callback, errorCallback){
			if(ctxs.shopContext.busy){
				return;
			}
			if(!ctxs.shopContext.isFunctionalityAllowed(window.retailFunctions['CANCEL_TICKET'])){
				return;
			}
			function action(){
				ctxs.shopContext.hideOperationStatusMessage();
				if(ctxs.shopContext.operator && ctxs.shopContext.operator.logged){
					ctxs.shopContext.setBusy();
		  			const params = {
						systemCode : systemCode,
						lingua: xs_languageCode,
						hash: '',
						sessionToken : ctxs.shopContext.operator.sessionToken,
						ticketId : ticketId,
						identityPlayer : ctxs.shopContext.cfForPurchase
	    			};
					$.ajax({
			    		type: "POST",
			    		url : getConfiguration().api['shop.cancelTicket'],
			    		data: params,
			    		async : true,
			    		success : (data) => {
			    			ctxs.shopContext.setFree();
			    			ctxs.shopContext.setCfForPurchase(null);
			    			if(data != null){
			    				const result = JSON.parse(data);
			    				if(result.code == 0 || (result.object && result.object.promotions)){
			    					ctxs.shopContext.decreaseCustomerBalance(result.object.amount);
			    					ctxs.shopContext.setTerminalBalance(result.object.terminalBalance);
			    					// print receipt
			    					result.showOperatorName = !ctxs.shopContext.isFunctionalityAllowed(window.retailFunctions['HIDE_OPERATOR_ON_RECEIPT']);
			    					result.showTerminalBalance = !ctxs.shopContext.isFunctionalityAllowed(window.retailFunctions['HIDE_CASH_BALANCE_ON_RECEIPT']);
			    					shopReceiptPrinterContext.printCancelTicketReceipt(result, false);
			    					if(callback){
			    						callback();
			    					}
			    				}
			    				else {
			    					ctxs.shopContext.setOperationStatusMessage(true, 'error', result.code + " - [" + ticketId + "] " + result.description);
			    					if(result.code == -5307){
			    						window.removeLoggedParametersOnLS();
			    						ctxs.shopContext.setShopUser({logged : false, operator : true, selfCashier : false});
			    						window.location.reload();	
			    					}
			    					else if(result.code == -5281){
				    					ctxs.shopContext.showCfPopup(() => {
				    						ctxs.shopContext.cancelTicket(ticketId, callback);
				    					});
			    					}
			    					else {
			    						ctxs.shopContext.setOperationStatusMessage(true, 'error', result.code + " - [" + ticketId + "] " + result.description);
			    						if(errorCallback){
			    							errorCallback(result);
			    						}
			    					}

			    				}
			    			}
			    			else{
			    				ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error');
			    				if(errorCallback){
			    					errorCallback({code : -1, description : 'Generic Error'});
			    				}
			    			}
			    		},
			    		error : (errorData) => {
							console.log(errorData);
			    			ctxs.shopContext.setFree();
			    			ctxs.shopContext.setCfForPurchase(null);
			    			ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error');
			    			if(errorCallback){
			    				errorCallback({code : -1, description : 'Generic Error'});
			    			}
			    		}	
			       });	
				}
			}
			
			const configuration = getConfiguration();
			const askForPaper = configuration.rs && configuration.rs.cfp && window.XSocket;
			if(!askForPaper){
				action();
			}
			else{
				ctxs.shopContext.setBusy();
				window.XSocket.askForPaper('CANCEL_TICKET', (data) => {
					if(data.body === 'OK'){
						selfContext.setPaperCaseEmpty(false);
						ctxs.shopContext.setFree();
						action();		  
					}
					else {
						ctxs.shopContext.setFree();
						ctxs.shopContext.setCfForPurchase(null);
						selfContext.setPaperCaseEmpty(true, data.body);
					}
			    });
			}
		},
		
		cashout : function(ticket, successCallback, errorCallback){
			if(ctxs.shopContext.busy){
				return;
			}
			if(!ctxs.shopContext.isFunctionalityAllowed(window.retailFunctions['CASHOUT'])){
				return;
			}
			function action(){
				ctxs.shopContext.hideOperationStatusMessage();
				if(ctxs.shopContext.operator && ctxs.shopContext.operator.logged){
					ctxs.shopContext.setBusy();
		  			const cf = ctxs.shopContext.cfForPurchase;
					const sessionTokenOperator = ctxs.shopContext.operator.sessionToken;	
					function startTimerOperations(pollingData) {
						if(pollingData.delay > 0){
							selfContext.freezeAll(getLabel('cashout.wait_live_delay'), null, pollingData.delay);						
						}
					}
					cashoutTicket(sessionTokenOperator, ticket.id, ticket.amn, ticket.amnc, 1, cf, startTimerOperations, (response) => {	
						selfContext.unfreezeAll();
						ctxs.shopContext.setFree();
						ctxs.shopContext.setCfForPurchase(null);
						if(response.returnCode.code === 0 || response.returnCode.code === 1024){
	    					//window.printTicket(ticket.id, false, true);
	    					const printData = {
	    						ticketId : ticket.id,
	    						cashoutAmount : ticket.amnc,
	    						terminalBalance: ctxs.shopContext.operator.terminalBalance - ticket.amnc,
	    						operatorUsername :  ctxs.shopContext.operator.operatorUsername,
	    						idTag : ctxs.shopContext.operator.idTag,
	    						shopDescr : ctxs.shopContext.operator.shopDescr,
	    						shopId : ctxs.shopContext.operator.shopId,
	    						showOperatorName : !ctxs.shopContext.isFunctionalityAllowed(window.retailFunctions['HIDE_OPERATOR_ON_RECEIPT']),
				    			showTerminalBalance : !ctxs.shopContext.isFunctionalityAllowed(window.retailFunctions['HIDE_CASH_BALANCE_ON_RECEIPT'])
	    					}
	    					shopReceiptPrinterContext.printCashoutReceipt(printData, false);
	    					ctxs.shopContext.decreaseCustomerBalance(ticket.amnc);
	    					ctxs.shopContext.reloadShopUser();
	    					successCallback && successCallback();
    					}
    					else{
    						if(response.returnCode.code == -5307){
			    				window.removeLoggedParametersOnLS();
			    				ctxs.shopContext.setShopUser({logged : false, operator : true, selfCashier : false});
			    				window.location.reload();	
			    			}
			    			else{
			    				ctxs.shopContext.setOperationStatusMessage(true, 'error', response.returnCode.code + ' - ' + response.returnCode.description);    		
			    				if(response.returnCode.code == -5281){
									ctxs.shopContext.showCfPopup(() => {
							    		ctxs.shopContext.cashout(ticket, successCallback, errorCallback);
							    	});		
			    				}
			    				else{
				    				errorCallback && errorCallback(response);
			    				}
			    			}

    					}
					},
					(errorData) => {
						errorCallback && errorCallback(errorData);
						ctxs.shopContext.setFree();
						ctxs.shopContext.setCfForPurchase(null);
    					ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error');
					});
				}
			}
			const configuration = getConfiguration();
			const askForPaper = configuration.rs && configuration.rs.cfp && window.XSocket;
			if(!askForPaper){
				action();
			}
			else{
				ctxs.shopContext.setBusy();
				window.XSocket.askForPaper('CASHOUT_TICKET', (data) => {
					if(data.body === 'OK'){
						selfContext.setPaperCaseEmpty(false);
						ctxs.shopContext.setFree();
						action();		  
					}
					else {
						ctxs.shopContext.setFree();
						ctxs.shopContext.setCfForPurchase(null);
						selfContext.setPaperCaseEmpty(true, data.body);
						errorCallback && errorCallback();
					}
			    });
			}
		},
		detailedBalance : function(date){
			if(ctxs.shopContext.busy){
				return;
			}
			if(!ctxs.shopContext.isFunctionalityAllowed(window.retailFunctions['DETAILED_BALANCE'])){
				return;
			}
			
			function action(){
				ctxs.shopContext.hideOperationStatusMessage();
				if(ctxs.shopContext.operator && ctxs.shopContext.operator.logged){
					ctxs.shopContext.setBusy();
		  			const params = {
						systemCode : systemCode,
						lingua: xs_languageCode,
						hash: '',
						sessionToken : ctxs.shopContext.operator.sessionToken,
						date
	    			};
					$.ajax({
			    		type: "POST",
			    		url : getConfiguration().api['shop.detailedBalance'],
			    		data: params,
			    		async : true,
			    		success : (data) => {
			    			ctxs.shopContext.setFree();
			    			if(data != null){
			    				const result = JSON.parse(data);
			    				if(result.code == 0){	
			    					// print receipt
			    					result.operator = ctxs.shopContext.operator.operatorUsername;
			    					shopReceiptPrinterContext.printDetailedBalance(result, false);
			    				}
			    				else {
			    					ctxs.shopContext.setOperationStatusMessage(true, 'error', result.code + " - " + result.description);
			    					if(result.code == -5307){
			    						window.removeLoggedParametersOnLS();
			    						ctxs.shopContext.setShopUser({logged : false, operator : true, selfCashier : false});
			    						window.location.reload();	
			    					}

			    				}
			    			}
			    			else{
			    				ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error');
			    			}
			    		},
			    		error : (errorData) => {
			    			ctxs.shopContext.setFree();
			    			ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error');
			    		}	
			       });	
				}
			}
			const configuration = getConfiguration();
			const askForPaper = configuration.rs && configuration.rs.cfp && window.XSocket;
			if(!askForPaper){
				action();
			}
			else{
				ctxs.shopContext.setBusy();
				window.XSocket.askForPaper('DETAILED_BALANCE', (data) => {
					if(data.body === 'OK'){
						selfContext.setPaperCaseEmpty(false);
						ctxs.shopContext.setFree();
						action();		  
					}
					else {
						ctxs.shopContext.setFree();
						selfContext.setPaperCaseEmpty(true, data.body);
					}
			    });
			}
		},
		
		posBalance : function(dateFrom, dateTo, sortedByOperator){
			if(ctxs.shopContext.busy){
				return;
			}
			const permission = sortedByOperator? 'POS_BALANCE_SORTED_BY_OPERATOR' : 'POS_BALANCE';
			if(!ctxs.shopContext.isFunctionalityAllowed(window.retailFunctions[permission])){
				return;
			}
			
			function action(){
				ctxs.shopContext.hideOperationStatusMessage();
				if(ctxs.shopContext.operator && ctxs.shopContext.operator.logged){
					ctxs.shopContext.setBusy();
		  			const params = {
						systemCode : systemCode,
						lingua: xs_languageCode,
						hash: '',
						sessionToken : ctxs.shopContext.operator.sessionToken,
						dateFrom,
						dateTo,
						sortedByOperator
	    			};
					$.ajax({
			    		type: "POST",
			    		url : getConfiguration().api['shop.posBalance'],
			    		data: params,
			    		async : true,
			    		success : (data) => {
			    			ctxs.shopContext.setFree();
			    			if(data != null){
			    				const result = JSON.parse(data);
			    				if(result.code == 0){	
			    					// print receipt
			    					result.operator = ctxs.shopContext.operator.operatorUsername;
			    					result.pvend = ctxs.shopContext.operator.pvend;
			    					shopReceiptPrinterContext.printPosBalance(result, false);
			    				}
			    				else {
			    					ctxs.shopContext.setOperationStatusMessage(true, 'error', result.code + " - " + result.description);
			    					if(result.code == -5307){
			    						window.removeLoggedParametersOnLS();
			    						ctxs.shopContext.setShopUser({logged : false, operator : true, selfCashier : false});
			    						window.location.reload();	
			    					}

			    				}
			    			}
			    			else{
			    				ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error');
			    			}
			    		},
			    		error : (errorData) => {
			    			ctxs.shopContext.setFree();
			    			ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error');
			    		}	
			       });	
				}
			}
			const configuration = getConfiguration();
			const askForPaper = configuration.rs && configuration.rs.cfp && window.XSocket;
			if(!askForPaper){
				action();
			}
			else{
				ctxs.shopContext.setBusy();
				window.XSocket.askForPaper('DETAILED_BALANCE', (data) => {
					if(data.body === 'OK'){
						selfContext.setPaperCaseEmpty(false);
						ctxs.shopContext.setFree();
						action();		  
					}
					else {
						ctxs.shopContext.setFree();
						selfContext.setPaperCaseEmpty(true, data.body);
					}
			    });
			}
		},
		
		posBalanceReport : function(dateFrom, dateTo){
			if(ctxs.shopContext.busy){
				return;
			}
			if(!ctxs.shopContext.isFunctionalityAllowed(window.retailFunctions['POS_BALANCE_REPORT'])){
				return;
			}
			
			function action(){
				ctxs.shopContext.hideOperationStatusMessage();
				if(ctxs.shopContext.operator && ctxs.shopContext.operator.logged){
					ctxs.shopContext.setBusy();
		  			const params = {
						systemCode : systemCode,
						lingua: xs_languageCode,
						hash: '',
						sessionToken : ctxs.shopContext.operator.sessionToken,
						dateFrom,
						dateTo
	    			};
					$.ajax({
			    		type: "POST",
			    		url : getConfiguration().api['shop.posBalanceReport'],
			    		data: params,
			    		async : true,
			    		success : (data) => {
			    			ctxs.shopContext.setFree();
			    			if(data != null){
			    				const result = JSON.parse(data);
			    				if(result.code == 0){	
			    					// print receipt
			    					result.operator = ctxs.shopContext.operator;
			    					result.fromDate = dateFrom;
			    					result.toDate = dateTo;
			    					shopReceiptPrinterContext.printPosBalanceReport(result, false);
			    				}
			    				else {
			    					ctxs.shopContext.setOperationStatusMessage(true, 'error', result.code + " - " + result.description);
			    					if(result.code == -5307){
			    						window.removeLoggedParametersOnLS();
			    						ctxs.shopContext.setShopUser({logged : false, operator : true, selfCashier : false});
			    						window.location.reload();	
			    					}

			    				}
			    			}
			    			else{
			    				ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error');
			    			}
			    		},
			    		error : (errorData) => {
			    			ctxs.shopContext.setFree();
			    			ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error');
			    		}	
			       });	
				}
			}
			const configuration = getConfiguration();
			const askForPaper = configuration.rs && configuration.rs.cfp && window.XSocket;
			if(!askForPaper){
				action();
			}
			else{
				ctxs.shopContext.setBusy();
				window.XSocket.askForPaper('DETAILED_BALANCE', (data) => {
					if(data.body === 'OK'){
						selfContext.setPaperCaseEmpty(false);
						ctxs.shopContext.setFree();
						action();		  
					}
					else {
						ctxs.shopContext.setFree();
						selfContext.setPaperCaseEmpty(true, data.body);
					}
			    });
			}
		},
		
		dailyShopDetailedBalance : function(){
			if(ctxs.shopContext.busy){
				return;
			}
			if(!ctxs.shopContext.isFunctionalityAllowed(window.retailFunctions['DAILY_DETAILED_BALANCE_SHOP'])){
				return;
			}
			function action(){
				ctxs.shopContext.hideOperationStatusMessage();
				if(ctxs.shopContext.operator && ctxs.shopContext.operator.logged){
					ctxs.shopContext.setBusy();
		  			const params = {
						systemCode : systemCode,
						lingua: xs_languageCode,
						hash: '',
						sessionToken : ctxs.shopContext.operator.sessionToken,
						date :  getNowTimestamp('YYYYMMDD')
	    			};
					$.ajax({
			    		type: "POST",
			    		url : getConfiguration().api['shop.dailyDetailedBalanceShop'],
			    		data: params,
			    		async : true,
			    		success : (data) => {
			    			ctxs.shopContext.setFree();
			    			if(data != null){
			    				const result = JSON.parse(data);
			    				if(result.code == 0){	
			    					// print receipt
			    					result.operator = ctxs.shopContext.operator;
			    					shopReceiptPrinterContext.printDailyShopDetailedBalance(result, false);
			    				}
			    				else {
			    					ctxs.shopContext.setOperationStatusMessage(true, 'error', result.code + " - " + result.description);
			    					if(result.code == -5307){
			    						window.removeLoggedParametersOnLS();
			    						ctxs.shopContext.setShopUser({logged : false, operator : true, selfCashier : false});
			    						window.location.reload();	
			    					}

			    				}
			    			}
			    			else{
			    				ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error');
			    			}
			    		},
			    		error : (errorData) => {
			    			ctxs.shopContext.setFree();
			    			ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error');
			    		}	
			       });	
				}
			}
			const configuration = getConfiguration();
			const askForPaper = configuration.rs && configuration.rs.cfp && window.XSocket;
			if(!askForPaper){
				action();
			}
			else{
				ctxs.shopContext.setBusy();
				window.XSocket.askForPaper('DETAILED_BALANCE', (data) => {
					if(data.body === 'OK'){
						selfContext.setPaperCaseEmpty(false);
						ctxs.shopContext.setFree();
						action();		  
					}
					else {
						ctxs.shopContext.setFree();
						selfContext.setPaperCaseEmpty(true, data.body);
					}
			    });
			}
		},
		
		monthlyCommissionReport : function(){
			if(ctxs.shopContext.busy){
				return;
			}
			if(!ctxs.shopContext.isFunctionalityAllowed(window.retailFunctions['MONTHLY_COMMISSION_REPORT'])){
				return;
			}
			function action(){
				ctxs.shopContext.hideOperationStatusMessage();
				if(ctxs.shopContext.operator && ctxs.shopContext.operator.logged){
					ctxs.shopContext.setBusy();
		  			const params = {
						systemCode : systemCode,
						lingua: xs_languageCode,
						hash: '',
						sessionToken : ctxs.shopContext.operator.sessionToken,
						date :  getNowTimestamp('YYYYMMDD')
	    			};
					$.ajax({
			    		type: "POST",
			    		url : getConfiguration().api['shop.monthlyCommissionReport'],
			    		data: params,
			    		async : true,
			    		success : (data) => {
			    			ctxs.shopContext.setFree();
			    			if(data != null){
			    				const result = JSON.parse(data);
			    				if(result.code == 0){	
			    					// print receipt
			    					result.operator = ctxs.shopContext.operator;
			    					shopReceiptPrinterContext.printMonthlyCommisionReport(result, false);
			    				}
			    				else {
			    					ctxs.shopContext.setOperationStatusMessage(true, 'error', result.code + " - " + result.description);
			    					if(result.code == -5307){
			    						window.removeLoggedParametersOnLS();
			    						ctxs.shopContext.setShopUser({logged : false, operator : true, selfCashier : false});
			    						window.location.reload();	
			    					}

			    				}
			    			}
			    			else{
			    				ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error');
			    			}
			    		},
			    		error : (errorData) => {
			    			ctxs.shopContext.setFree();
			    			ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error');
			    		}	
			       });	
				}
			}
			const configuration = getConfiguration();
			const askForPaper = configuration.rs && configuration.rs.cfp && window.XSocket;
			if(!askForPaper){
				action();
			}
			else{
				ctxs.shopContext.setBusy();
				window.XSocket.askForPaper('DETAILED_BALANCE', (data) => {
					if(data.body === 'OK'){
						selfContext.setPaperCaseEmpty(false);
						ctxs.shopContext.setFree();
						action();		  
					}
					else {
						ctxs.shopContext.setFree();
						selfContext.setPaperCaseEmpty(true, data.body);
					}
			    });
			}
		},
		refreshMobilePosCommission : function(){
			if(!ctxs.shopContext.busy){
				ctxs.shopContext.monthlyDetailedCommissionReport(function(commissions){
					ctxs.shopContext.update({totalCommission : commissions.total});
				});
			}
			else {
				setTimeout(() => {
					ctxs.shopContext.refreshMobilePosCommission();
				}, 100);
			}

		},
		monthlyDetailedCommissionReport : function(callback){
			if(ctxs.shopContext.busy){
				return;
			}
			const allowed = ctxs.shopContext.isFunctionalityAllowed(window.retailFunctions['MONTHLY_DETAILED_COMMISSION_REPORT']);
			if(!allowed){
				return;
			}
			function action(){
				ctxs.shopContext.hideOperationStatusMessage();
				if(ctxs.shopContext.operator && ctxs.shopContext.operator.logged){
					ctxs.shopContext.setBusy();
		  			const params = {
						systemCode : systemCode,
						lingua: xs_languageCode,
						hash: '',
						sessionToken : ctxs.shopContext.operator.sessionToken
	    			};
					$.ajax({
			    		type: "POST",
			    		url : getConfiguration().api['shop.monthlyDetailedCommissionReport'],
			    		data: params,
			    		async : true,
			    		success : (data) => {
			    			ctxs.shopContext.setFree();
			    			if(data != null){
			    				const result = JSON.parse(data);
			    				if(result.code == 0){	
									callback(result);
			    				}
			    				else {
			    					ctxs.shopContext.setOperationStatusMessage(true, 'error', result.code + " - " + result.description);
			    					if(result.code == -5307){
			    						window.removeLoggedParametersOnLS();
			    						ctxs.shopContext.setShopUser({logged : false, operator : true, selfCashier : false});
			    						window.location.reload();	
			    					}

			    				}
			    			}
			    			else{
			    				ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error');
			    			}
			    		},
			    		error : (errorData) => {
			    			ctxs.shopContext.setFree();
			    			ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error');
			    		}	
			       });	
				}
			}
			action();
		},		
		loadOperator : function(unloggedCallback,loggedCallback){
			if(ctxs.shopContext.enabled){
				const loggedParameters = window.getLoggedParamsFromLS();
				if(loggedParameters != null){
					const sessionToken = loggedParameters.token || loggedParameters.sessionToken;
					const url = getConfiguration().api['shop.getShopUser'];
		  			const params = {
	    					systemCode : systemCode,
	    					lingua: xs_languageCode,
	    					hash: '',
	    					sessionToken : sessionToken,
	    					type : 'operator'
	    			}
		  			
			    	$.ajax({
			    		type: "POST",
			    		url : url,
			    		data: params,
			    		async : true,
			    		success : (data) => {
			    			if(data){
								console.debug('getShopUser response is '+data);
			    				const operator = JSON.parse(data);
			    				operator.operator = true;
			    				operator.selfCashier = false;
			    				operator.userBalance = window.getCustomerBalanceFromLS();
			    				window.setLoggedParametersOnLS(operator);
			    				ctxs.shopContext.setShopUser(operator);
			    				if(props.apkPosLite){
			    					ctxs.shopContext.refreshMobilePosCommission();
			    				}	
								if(loggedCallback) {
									loggedCallback(operator);
								}	    				
			    			}
			    			else{
								console.warn('getShopUser response is NULL');
			    				ctxs.shopContext.setShopUser({logged : false, operator : true, selfCashier : false});
			    				window.removeLoggedParametersOnLS();
								if(unloggedCallback) {
									unloggedCallback();
								}
			    			}
			    		},
			    		error : (errorData, textStatus, errorThrown) => {
							console.error("Error in calling getShopUser "+textStatus+" "+errorThrown);
			    			ctxs.shopContext.setShopUser({logged : false, operator : true, selfCashier : false});
			    			window.removeLoggedParametersOnLS();
							if(unloggedCallback) {
								unloggedCallback();
							}
			    		}	
			       });	
				}
				else{
					ctxs.shopContext.setShopUser({logged : false, operator : true, selfCashier : false});
					window.removeLoggedParametersOnLS();
				}
				
			}

		},
		
		setCfForPurchase : function(cf){
			ctxs.shopContext.cfForPurchase = cf;
			setShopContext(function(prev){
				return {
					...prev,
					cfForPurchase : cf
				}
			});
			if(ctxs.shopContext.isSlaveOfAnotherShopConf){
				window.shopApi.setCfForPurchase(cf);
			}
		},
		
		loadSelfCashier : function (unloggedCallback){	
			const loggedParameters = window.getVoucherParamsFromLS();
			if(loggedParameters != null){
				const oldTicketsList = loggedParameters.lastTickets || [];
				const sessionToken = loggedParameters.token || loggedParameters.sessionToken;
				ctxs.shopContext.setUserState('validating');
				const url = getConfiguration().api['shop.getShopUser'];
	  			const params = {
    					systemCode : systemCode,
    					lingua: xs_languageCode,
    					hash: '',
    					sessionToken : sessionToken,
    					type : 'self-cashier'
    			}			
		    	$.ajax({
		    		type: "POST",
		    		url : url,
		    		data: params,
		    		async : true,
		    		success : (data) => {
		    			if(data){
							console.debug('getShopUser response is '+data);
		    				const cashier = JSON.parse(data);
		    				cashier.operator = false;
		    				cashier.selfCashier = true;
		    				const lastTicket = window.getLastTicketPurchasedOnLS();
		    				if(lastTicket && lastTicket.protocol === 'PSQF'){
		    					let found = false;
		    					for(let kt in oldTicketsList){
		    						if(oldTicketsList[kt].id === lastTicket.id){
		    							found = true;
		    						}
		    					}
		    					if(!found){
		    						//add to the top of the list
		    						oldTicketsList.unshift({
		    							id : lastTicket.id,
		    							win : lastTicket.win || 0,
		    							amount : lastTicket.stake || 0
		    						});
		    					}
		    				}
		    				cashier.lastTickets = oldTicketsList.slice(0,5); // just last 5 tickets
		    				if(window.NUM_CASSA){
		    					cashier.cashierNumber = window.NUM_CASSA;
		    				}
		    				
		    				ctxs.shopContext.setShopUser(cashier);
		    				window.setVoucherParametersOnLS(cashier);
		    				ctxs.shopContext.setUserState('validated');
		    				if(ctxs.shopContext.selfCashier){
			    				if(ctxs.shopContext.selfCashier.logged && ctxs.shopContext.selfCashier.deviceId){
			    					ctxs.shopContext.setPollingBalanceUpdate();
			    				}
			    				if(!ctxs.shopContext.selfCashier.logged && unloggedCallback){
			    					unloggedCallback();
			    				}
		    				}

		    			}
		    			else{
							console.warn('getShopUser response is NULL');
		    				ctxs.shopContext.setShopUser({logged : false, operator : false, selfCashier : true});
		    				ctxs.shopContext.setUserState('unlogged');
		    				if(unloggedCallback){
		    					unloggedCallback();
		    				}
		    			}
		    		},
		    		error : (errorData, textStatus, errorThrown) => {
						console.error("Error in calling getShopUser "+textStatus+" "+errorThrown);
						setTimeout(() => {
							ctxs.shopContext.loadSelfCashier(unloggedCallback);
						}, 500);
		    		}	
		       });	
			}
			else {
				ctxs.shopContext.setShopUser({logged : false, operator : false, selfCashier : true});
				ctxs.shopContext.setUserState('unlogged');
				if(unloggedCallback){
					unloggedCallback();
				}
			}
		},
		
		loadShopBooker : function(){
			const cn = ctxs.shopContext.skinProperties? ctxs.shopContext.skinProperties.cnPrenotatore : 0;
			const pvend = ctxs.shopContext.skinProperties? ctxs.shopContext.skinProperties.pvendPrenotatore : 0;
			ctxs.shopContext.setShopUser({
				logged : false, 
				operator : false, 
				selfCashier : false, 
				shopBooker: true,
				cn,
				pvend
			});
		},
		
		loginSelfCashier : function (voucherCode){
			if(ctxs.shopContext.busy){
				return;
			}
			
			ctxs.shopContext.hideOperationStatusMessage();
			if(ctxs.shopContext.selfCashier == null || ctxs.shopContext.selfCashier.logged == false){
				ctxs.shopContext.setBusy();
				const url = getConfiguration().api['shop.loginSelfCashier'];
	  			const params = {
    					systemCode : systemCode,
    					lingua: xs_languageCode,
    					hash: '',
    					pvend : selfContext.idPvend,
    					voucherCode
    			}
		    	$.ajax({
		    		type: "POST",
		    		url : url,
		    		data: params,
		    		async : true,
		    		success : (data) => {
		    			ctxs.shopContext.setFree();
		    			if(data != null){
		    				const selfCashierContainer = JSON.parse(data);
		    				if(selfCashierContainer.code == 0){
			    				const selfCashier = selfCashierContainer.object;
			    				selfCashier.operator = false;
			    				selfCashier.selfCashier = true;
			    				window.setVoucherParametersOnLS(selfCashier);
			    				ctxs.shopContext.setShopUser(selfCashier);
			    				if(window.shopApiSlave != null){
			    					window.shopApiSlave.reloadShopUser();
			    				}
		    				}
		    				else {
				    			ctxs.shopContext.setShopUser({logged : false, operator : false, selfCashier : true});
		    					ctxs.shopContext.setOperationStatusMessage(true, 'error', selfCashierContainer.code + " - " + selfCashierContainer.description);
		    				}
		    			}
		    			else{
		    				ctxs.shopContext.setShopUser({logged : false, operator : false, selfCashier : true});
		    				ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error.');
		    			}
		    		},
		    		error : (errorData) => {
		    			ctxs.shopContext.setFree();
		    			ctxs.shopContext.setShopUser({logged : false, operator : false, selfCashier : true});
		    			ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error.');
		    		}	
		       });	
			}
		},
		
		loginPhysicalSelf : function (){
			if(ctxs.shopContext.selfCashier == null || ctxs.shopContext.selfCashier.logged === false){
				const url = getConfiguration().api['shop.loginSelfCashier'];
	  			const params = {
    					systemCode : systemCode,
    					lingua: xs_languageCode,
    					hash: '',
    					idTag : selfContext.idTag,
    					pvend : selfContext.idPvend,
    					deviceId : selfContext.deviceId
    			}		  			
		    	$.ajax({
		    		type: "POST",
		    		url : url,
		    		data: params,
		    		async : true,
		    		success : (data) => {
		    			if(data != null){
		    				const selfCashierContainer = JSON.parse(data);
		    				if(selfCashierContainer.code == 0){
			    				const selfCashier = selfCashierContainer.object;
			    				selfCashier.operator = false;
			    				selfCashier.selfCashier = true;
			    				window.setVoucherParametersOnLS(selfCashier);
			    				ctxs.shopContext.setShopUser(selfCashier);
			    				ctxs.shopContext.setPollingBalanceUpdate();
		    				}
		    				else {
				    			ctxs.shopContext.setShopUser({logged : false, operator : false, selfCashier : true});
				    			selfContext.freezeAll(selfCashierContainer.description, selfCashierContainer.code);
		    				}
		    			}
		    			else{
		    				ctxs.shopContext.setShopUser({logged : false, operator : false, selfCashier : true});
		    				selfContext.freezeAll("Errore comunicazione centro servizi");
		    			}
		    		},
		    		error : (errorData) => {
		    			ctxs.shopContext.setShopUser({logged : false, operator : false, selfCashier : true});
		    			selfContext.freezeAll("Errore comunicazione centro servizi");
		    		}	
		       });	
			}
		},
		// socket handler for coin inserted event
		handleSelfCashierBalanceUpdate : function(amount, socketCallback){

			if(ctxs.shopContext.selfCashier && ctxs.shopContext.selfCashier.logged){
				const url = getConfiguration().api['shop.getShopUser'];
	  			const params = {
					systemCode : systemCode,
					lingua: xs_languageCode,
					hash: '',
					sessionToken : ctxs.shopContext.selfCashier.sessionToken,
					type : 'self-cashier'
    			}		  			
		    	$.ajax({
		    		type: "POST",
		    		url : url,
		    		data: params,
		    		async : true,
		    		success : (data) => {
		    			if(data != null){
							console.debug('getShopUser response is '+data);
		    				const selfCashier = JSON.parse(data);
		    				ctxs.shopContext.setShopUser(selfCashier);
		    				socketCallback && socketCallback();
		    			}
		    			else{
							console.warn('getShopUser response is NULL');
		    				selfContext.freezeAll("Errore comunicazione centro servizi");
		    				socketCallback &&  socketCallback();
		    			}
		    		},
		    		error : (errorData, textStatus, errorThrown) => {
						console.error("Error in calling getShopUser "+textStatus+" "+errorThrown);
		    			selfContext.freezeAll("Errore comunicazione centro servizi");
		    			socketCallback && socketCallback();
		    		}	
		       });
				
			}
			else {
				socketCallback();
				selfContext.freezeAll("TERMINALE NON LOGGATO. CONTATTA UN'OPERATORE.");
			}
		},
		
		physicalSelfGetBalance : function(){
			if(ctxs.shopContext.selfCashier && ctxs.shopContext.selfCashier.logged){
				const url = getConfiguration().api['shop.physicalSelfGetBalance'];
	  			const idFsc = ctxs.shopContext.selfCashier.idFsc;
	  			let idTag = ctxs.shopContext.selfCashier.idTag;
	  			let idCn = 0;
	  			let idPvend = 0;
	  			if(ctxs.shopContext.selfCashier.servicesMap['CASSA']){
	  				idCn = ctxs.shopContext.selfCashier.servicesMap['CASSA'].split("/")[0];
	  				idPvend = ctxs.shopContext.selfCashier.servicesMap['CASSA'].split("/")[1];
	  			}
	  			
				const params = {
					systemCode : systemCode,
					lingua: xs_languageCode,
					hash: '',
					sessionToken : ctxs.shopContext.selfCashier.sessionToken,
					idFsc,
					idCn,
					idPvend,
					idTag
    			}		  			
		    	$.ajax({
		    		type: "POST",
		    		url : url,
		    		data: params,
		    		async : true,
		    		success : (data) => {
		    			if(data != null){
		    				const balanceContainer = JSON.parse(data);
		    				const selfCashier = ctxs.shopContext.selfCashier;
		    				selfCashier.physicalSelfBalance = balanceContainer.object;
		    				ctxs.shopContext.setShopUser(selfCashier);
		    				if(ctxs.shopContext.selfCashier.logged){
		    					ctxs.shopContext.setPollingBalanceUpdate();		    					
		    				}
		    			}
		    		},
		    		error : (errorData) => {
	    				if(ctxs.shopContext.selfCashier.logged){
	    					ctxs.shopContext.setPollingBalanceUpdate();		    					
	    				}
		    		}	
		       });
				
			}
		},
		
		setPollingBalanceUpdate : function() {
			const millis = retailConf.tpsb;
			if(!millis){
				return;
			}
			clearTimeout(ctxs.shopContext.balanceUpdateTimeoutRef);
			const balanceUpdateTimeoutRef = setTimeout(() => {
				ctxs.shopContext.physicalSelfGetBalance();
			}, millis);
			
			setShopContext(function(prev){
				return {
					...prev,
					balanceUpdateTimeoutRef : balanceUpdateTimeoutRef
				}
			});
		},
		
		handleVoucherRead : function (voucherId, socketCallback){
			if(ctxs.shopContext.busy){
				return;
			}
			const lastVoucherRead = localStorage.getItem('last_physical_rest_self_voucher_read');
			if(lastVoucherRead && lastVoucherRead.toUpperCase() === voucherId.toUpperCase()){
				// if the final user leave his voucher in the case, I ignore the message
				if(!selfContext.freezeAppMessagePermanent){
    				selfContext.freezeAll("Questo voucher è stato già ricaricato. Per favore rimuovilo dal lettore");
	    			setTimeout(() => {
	    				selfContext.unfreezeAll();
	    			}, 3000);
				}
				if(socketCallback) {
					socketCallback();
				}				
				return;	
			}
			ctxs.shopContext.setBusy();
			if(ctxs.shopContext.selfCashier && ctxs.shopContext.selfCashier.logged){
				const conf = getConfiguration();
				const url = conf.api['shop.reloadPhysicalSelfRestVoucher'];
	  			const params = {
					systemCode : systemCode,
					lingua: xs_languageCode,
					hash: '',
					sessionToken : ctxs.shopContext.selfCashier.sessionToken,
					voucherId : voucherId
    			}		  			
		    	$.ajax({
		    		type: "POST",
		    		url : url,
		    		data: params,
		    		async : true,
		    		success : (data) => {
		    			ctxs.shopContext.setFree();
		    			if(data != null){
		    				const selfCashierContainer = JSON.parse(data);
		    				if(selfCashierContainer.code == 0){
			    				const selfCashier = selfCashierContainer.object;
			    				selfCashier.operator = false;
			    				selfCashier.selfCashier = true;
			    				window.setVoucherParametersOnLS(selfCashier);
			    				localStorage.setItem("last_physical_rest_self_voucher_read", voucherId);
			    				ctxs.shopContext.setShopUser(selfCashier);
			    				const printableAmount = getCurrencyValue(selfCashier.voucherAmount, conf.cs.m, conf.cs.nd, conf.cs.ct);
			    				if(!selfContext.freezeAppMessagePermanent){
			    					selfContext.freezeAll("Ricaricati " + printableAmount);
				    				setTimeout(() => {
					    				selfContext.unfreezeAll();
					    			}, 2500);
			    				}
								
			    				if(socketCallback) {
									socketCallback();
								}	
		    				}
		    				else {
				    			if(!selfContext.freezeAppMessagePermanent){
				    				selfContext.freezeAll(selfCashierContainer.description, selfCashierContainer.code);
					    			setTimeout(() => {
					    				selfContext.unfreezeAll();
					    			}, 2500);
				    			}

				    			if(socketCallback) {
									socketCallback();
								}	
		    				}
		    			}
		    			else{
		    				if(!selfContext.freezeAppMessagePermanent){
			    				selfContext.freezeAll("Voucher non valido");
				    			setTimeout(() => {
				    				selfContext.unfreezeAll();
				    			}, 3000);
		    				}
		    				if(socketCallback) {
								socketCallback();
							}	
		    			}
		    		},
		    		error : (errorData) => {
		    			ctxs.shopContext.setFree();
		    			if(!selfContext.freezeAppMessagePermanent){
			    			selfContext.freezeAll("Errore comunicazione centro servizi");
			    			setTimeout(() => {
			    				selfContext.unfreezeAll();
			    			}, 3000);
		    			}
						if(socketCallback) {
							socketCallback();
						}	
		    		}	
		       });
				
			}
			else {
				ctxs.shopContext.setFree();
				if(socketCallback) {
					socketCallback();
				}	
				selfContext.freezeAll("TERMINALE NON LOGGATO. CONTATTA UN'OPERATORE.");
			}
		},

		handleTicketIdRead : function (ticketId, socketCallback){
			if(selfContext.freezeAppMessage){
				shopContext.ejectTicket(socketCallback);
			}else{
				if(selfContext.isUnderlyingScannerPDI()){
					ctxs.shopContext.update({ticketHeldInScanner: true});	
				}
				shopContext.handleShowCheckBet(ticketId, socketCallback);
			}
		},

		ejectTicket: function(callback) {
			ctxs.shopContext.update({ticketHeldInScanner: false});	
			if(selfContext.isUnderlyingScannerPDI()) {
				window.XSocket.ejectTicketFromScanner("FRONT","",callback);
			}
		},

		imprintTicket: function(stringToImprint,callback) {
			ctxs.shopContext.update({ticketHeldInScanner: false});	
			if(selfContext.isUnderlyingScannerPDI()) {
				window.XSocket.ejectTicketFromScanner("REAR",stringToImprint,callback);
			}
		},

		handleShowCheckBet : function (ticketId, socketCallback){
			selfContext.setShowCheckBet(true,ticketId);
			if(socketCallback){
				socketCallback(); // unlock the socket						
			}
		},
		
		setShopUser : function(user){
		
			if(ctxs.shopContext.type === 'TERMINAL'){
				ctxs.shopContext.operator = user;

				setShopContext(function(prev){
					return {
						...prev,
						operator : user
					}
				});
			}
			else if(ctxs.shopContext.type === 'SELF-CASHIER'){
				ctxs.shopContext.selfCashier = user;
				if(user.physicalVoucher && window.XSocket){
					window.XSocket.keepAliveBody.selfBalance = user.physicalSelfBalance;
					window.XSocket.keepAliveBody.maxSelfPlayerAmount = selfContext.maxSelfPlayerAmount? selfContext.maxSelfPlayerAmount : 0;
				}
				setShopContext(function(prev){
					return {
						...prev,
						selfCashier : user
					}
				});
			}
			else if(ctxs.shopContext.type === 'SHOP-BOOKER'){
				ctxs.shopContext.shopBooker = user;
				setShopContext(function(prev){
					return {
						...prev,
						shopBooker : user
					}
				});
			}
			
		},
		
		getShopUser : function(){
			if(ctxs.shopContext.type === 'TERMINAL'){
				return ctxs.shopContext.operator;				
			}
			else if(ctxs.shopContext.type === 'SELF-CASHIER'){
				return ctxs.shopContext.selfCashier;
			}
			else if(ctxs.shopContext.type === 'SHOP-BOOKER'){
				return ctxs.shopContext.shopBooker;
			}
		},
		
		reloadShopUser : function (unloggedCallback,loggedCallback){
			ctxs.shopContext.setCfForPurchase(null);
			if(ctxs.shopContext.type === 'TERMINAL'){
				ctxs.shopContext.loadOperator(unloggedCallback, loggedCallback);			
			}
			else if	(ctxs.shopContext.type === 'SELF-CASHIER'){
				ctxs.shopContext.loadSelfCashier(unloggedCallback);	
			}
			else if(ctxs.shopContext.type === 'SHOP-BOOKER'){
				ctxs.shopContext.loadShopBooker(unloggedCallback);
			}
			else {
				ctxs.shopContext.setShopUser({logged : false, operator : false, selfCashier : false});
			}
		},
		triggerReloadMainUser : function(amount){
			if(ctxs.shopContext.type === 'TERMINAL'){
				amount = amount? amount : 0;
				if(amount != 0){
					if(shopContext.isSlaveOfAnotherShopConf){
						// Increase the main one
						window.shopApi.increaseCustomerBalance(amount);
					}
					else{
						ctxs.shopContext.increaseCustomerBalance(amount);						
					}	
				}

				if(window.aggiornaDatiOperatore){
					// this function will load the main page operator. At the end of this operation, it will call my api.shop.reloadShopUser,
					// that will perform a stateUpdate.
					window.aggiornaDatiOperatore();				
				}
				else{
					ctxs.shopContext.reloadShopUser();
				}
				if(shopContext.isSlaveOfAnotherShopConf){
					// I've to trigger the main ShopConf to reload the user: in this case:
					// window.shopApi is the api from xshop, and shopApiSlave is from this ShopConf
					window.shopApi.reloadShopUser();
				}
			}
			else if(ctxs.shopContext.type === 'SELF-CASHIER'){
				if(window.refreshVoucherState){
					// this function will load the main page cashier. At the end of this operation, it will call my api.shop.reloadShopUser,
					// that will perform a stateUpdate.
					window.refreshVoucherState();
				}
				else{
					ctxs.shopContext.reloadShopUser();
				}
				if(shopContext.isSlaveOfAnotherShopConf){
					// I've to trigger the main ShopConf to reload the user: in this case:
					// window.shopApi is the api from xshop, and shopApiSlave is from this ShopConf
					window.shopApi.reloadShopUser();
				}
			}	
		},
		
		getLastTicketPurchased : function (){
			let lastTicket = window.getLastTicketPurchasedOnLS();
			if(!lastTicket){
				if(ctxs.shopContext.getShopUser()){
					const lastTickets = ctxs.shopContext.getShopUser().lastTickets;
					if(lastTickets != null && lastTickets.length > 0){
						lastTicket = {
								protocol : 'PSQF',
								id : lastTickets[0].id
						}
					}
				}
			}
			if(lastTicket){
				window.setLastTicketPurchasedOnLS(lastTicket.protocol, lastTicket.id, false, false);
			}
			return lastTicket;
		},
		
		getLastTicketProtocol : function (){
			const lastTicket = ctxs.shopContext.getLastTicketPurchased();
			if(lastTicket){
				return lastTicket.protocol;
			}
			return null;
		},
		
		reloadLastTicket : function(callback){
			const lastTicket = ctxs.shopContext.getLastTicketPurchased();
			const onlineSportbook = selfContext.sportbookPage === 'desktop-sportbook' || !selfContext.sportbookPage;
			if(lastTicket){
				if(!onlineSportbook && lastTicket.protocol === 'PSQF'){
					window.reloadTicketFunctionClass.reloadTicketBetslipSelf(lastTicket.id);
				}
				else if(onlineSportbook && lastTicket.protocol === 'PSQF'){
					window.reloadTicketFunctionClass.reloadTicketBetslipOnlineSportbook(lastTicket.id);
				}
				else if(lastTicket.protocol === 'PSV'){
					window.reloadTicketFunctionClass.reloadTicketBetslipSelf(lastTicket.id);
				}
				else{
					window.reloadTicket(lastTicket.id);					
				}
				return true;
			}
			if(callback){
				callback();
			}
			return false;
		},
		
		isAllowed : function (functionId){
			if(ctxs.shopContext.skinProperties && ctxs.shopContext.skinProperties.functions){
				return ctxs.shopContext.skinProperties.functions[functionId];
			}
			return false;
		},
				
		generateVoucher : function(amount, maxPlayableAmount, idPvend, operatorNickname, psqfPrematchEnabled, psqfLiveEnabled, psipEnabled, psvEnabled, lotteriesEnabled, operatorToken, callback){
			const url = getConfiguration().api['shop.generateSelfVoucher'];
			const requestForVoucher = {
					idPvend : idPvend,
					amount : amount,
					maxPlayableAmount : maxPlayableAmount,
					psqfPrematchEnabled : psqfPrematchEnabled,
					psqfLiveEnabled : psqfLiveEnabled,
					psipEnabled : psipEnabled,
					psvEnabled : psvEnabled,
					lotteriesEnabled : lotteriesEnabled,
					operatorNickname
			}
  			const params = {
					systemCode : systemCode,
					lingua: xs_languageCode,
					hash: '',
					jsonRequest : JSON.stringify(requestForVoucher),
					operatorToken : operatorToken
			}
	    	$.ajax({
	    		type: "POST",
	    		url : url,
	    		data: params,
	    		async : true,
	    		success : (data) => {
	    			if(data != null){
	    				const cashierContainer = JSON.parse(data);
	    				callback(cashierContainer);
	    			}
	    			else{
	    				ctxs.shopContext.setShopUser({logged : false, operator : false, selfCashier : true});
	    				callback();
	    			}
	    		},
	    		error : (errorData) => {
	    			ctxs.shopContext.setShopUser({logged : false, operator : false, selfCashier : true});
	    			callback();
	    		}	
	       });	
		
		},

		logoutSelfCashier : function(){
			
			function action(){
				// logout ctxs.shopContext.voucher, create a new one and print it
				if(ctxs.shopContext.selfCashier && ctxs.shopContext.selfCashier.logged && !ctxs.shopContext.busy){
					ctxs.shopContext.setBusy();
					const url = getConfiguration().api['shop.logoutSelfCashier'];
		  			const params = {
							systemCode : systemCode,
							lingua: xs_languageCode,
							hash: '',
							sessionToken : ctxs.shopContext.selfCashier.sessionToken
					}
			    	$.ajax({
			    		type: "POST",
			    		url : url,
			    		data: params,
			    		async : true,
			    		success : (data) => {
			    			ctxs.shopContext.setFree();
			    			if(data != null){
			    				window.removeVoucherParametersOnLS();
			    				const cashierContainer = JSON.parse(data);
			    				shopReceiptPrinterContext.printVoucherReceipt(cashierContainer.object, false);	
			    				// ctxs.shopContext.setShopUser does not work properly here. 
			    				// I guess that it's because we are in a callback in afunction   invoked by a window function (by socket handler)
			    				shopContext.setShopUser({logged : false, operator : false, selfCashier : true});
			    				
			    				if(window.shopApiSlave != null){
			    					window.shopApiSlave.reloadShopUser();
			    				}
			    			}
			    		},
			    		error : () => {
			    			ctxs.shopContext.setFree();
			    		}	
			       });	
				}
			}
			
			const configuration = getConfiguration();
			const askForPaper = configuration.rs && configuration.rs.cfp && window.XSocket;
			if(!askForPaper){
				action();
			}
			else{
				ctxs.shopContext.setBusy();
				window.XSocket.askForPaper('GENERATE_SELF_REST_VOUCHER', (data) => {
					if(data.body === 'OK'){
						selfContext.setPaperCaseEmpty(false);
						ctxs.shopContext.setFree();
						action();		  
					}
					else {
						selfContext.setPaperCaseEmpty(true, data.body);
						ctxs.shopContext.setFree();
					}
			    });
			}
			
		},
		
		generatePhysicalSelfRestVoucher : function(){
			if(ctxs.shopContext.busy){
				// retry in 100 ms
				setTimeout(() => {
					ctxs.shopContext.generatePhysicalSelfRestVoucher();
				}, 100);
				return;
			}
			if(ctxs.shopContext.selfCashier.physicalSelfBalance == 0){
				return;
			}
			function action(){
				if(ctxs.shopContext.selfCashier && ctxs.shopContext.selfCashier.logged && !ctxs.shopContext.busy){
					ctxs.shopContext.setBusy();
					const url = getConfiguration().api['shop.generatePhysicalSelfRestVoucher'];
					const params = {
						systemCode : systemCode,
						lingua: xs_languageCode,
						hash: '',
						sessionToken : ctxs.shopContext.selfCashier.sessionToken
	    			}
					const frontendTransactionId = generateFrontendTransactionId(ctxs.shopContext.selfCashier, GENERATE_REST_VOUCHER_RETRY); 
					if(frontendTransactionId){
						saveFrontendTransactionId(frontendTransactionId);
						params.frontendTransactionId = frontendTransactionId;
					}
			    	$.ajax({
			    		type: "POST",
			    		url : url,
			    		data: params,
			    		async : true,
			    		success : (data) => {
			    			ctxs.shopContext.setFree();
							removeFrontendTransactionId();
			    			if(data != null){
								console.debug('generatePhysicalSelfRestVoucher response is '+data);
			    				const voucherContainer = JSON.parse(data);
			    				if(voucherContainer.code == 0){
				    				const voucher = voucherContainer.object;
				    				shopReceiptPrinterContext.printVoucherReceipt(voucher, false);
				    				// redo login to be sure that the user is correctly binded with the database
				    				ctxs.shopContext.setShopUser({logged : false, operator : false, selfCashier : true});
				    				ctxs.shopContext.loginPhysicalSelf();
			    				}
			    				else {
					    			selfContext.freezeAll(voucherContainer.description, voucherContainer.code);
					    			setTimeout(() => {
					    				selfContext.unfreezeAll();
					    			}, 3000);
					    			
			    				}
			    			}
			    			else{
								console.warn('generatePhysicalSelfRestVoucher response is NULL');
			    				selfContext.freezeAll("Errore comunicazione centro servizi");
			    			}		    			
			    		},
			    		
			    		error : (errorData, textStatus, errorThrown) => {
							console.error("Error in calling generatePhysicalSelfRestVoucher "+textStatus+" "+errorThrown);
							ctxs.shopContext.setFree();
							ctxs.shopContext.generateRestFailureCallback(frontendTransactionId);
			    		}	
			       });	
				}
			}
			const configuration = getConfiguration();
			const askForPaper = configuration.rs && configuration.rs.cfp && window.XSocket;
			if(!askForPaper){
				action();
			}
			else{
				ctxs.shopContext.setBusy();
				window.XSocket.askForPaper('GENERATE_PHYSICAL_REST_VOUCHER', (data) => {
					if(data.body === 'OK'){
						selfContext.setPaperCaseEmpty(false);
						ctxs.shopContext.setFree();
						action();		  
					}
					else {
						ctxs.shopContext.setFree();
						selfContext.setPaperCaseEmpty(true, data.body);
					}
			    });
			}
			
		},

		generateRestFailureCallback : function(frontendTransactionId){
			const finalErrorCallback = () => {
				ctxs.shopContext.setFree();
			}	
			if(frontendTransactionId){
				// remove shadow to show correctly the popup
				$('.xshop-body').removeClass('retailShadow');
				selfContext.freezeAllPermanent(getLabel('general.operation_pending_no_shutdown'));
				// starting retry
				retryCheckGenerateRestVoucher(frontendTransactionId,
				(voucherContainer) => {
					// success callback
					ctxs.shopContext.setFree();
					selfContext.unfreezeAll();
					shopReceiptPrinterContext.printVoucherReceipt(voucherContainer.additionalData, false);
					// redo login to be sure that the user is correctly binded with the database
					ctxs.shopContext.setShopUser({logged : false, operator : false, selfCashier : true});
					ctxs.shopContext.loginPhysicalSelf();
				},
				() => {
					selfContext.unfreezeAll();
					finalErrorCallback();
				});
			}
			else{
				finalErrorCallback();
			}
		},

		startRetryRestFailureCallback : function (frontendTransactionId){
			if(ctxs.shopContext.busy){
				return;
			}
			ctxs.shopContext.setBusy();
			ctxs.shopContext.generateRestFailureCallback(frontendTransactionId);	
		},

		
		generatePhysicalSelfVoucherByOperator : function(amount){
			function action(){
				if(ctxs.shopContext.operator && ctxs.shopContext.operator.logged && !ctxs.shopContext.busy){
					ctxs.shopContext.setBusy();
					const url = getConfiguration().api['shop.generatePhysicalSelfVoucherByOperator'];
		  			const params = {
						systemCode : systemCode,
						lingua: xs_languageCode,
						hash: '',
						sessionToken : ctxs.shopContext.operator.sessionToken,
						amount : amount
	    			}		  			
			    	$.ajax({
			    		type: "POST",
			    		url : url,
			    		data: params,
			    		async : true,
			    		success : (data) => {
			    			ctxs.shopContext.setFree();
			    			if(data != null){
			    				const voucherContainer = JSON.parse(data);
			    				if(voucherContainer.code == 0){
				    				const voucher = voucherContainer.object;
				    				shopReceiptPrinterContext.printVoucherReceipt(voucher, false);
				    				ctxs.shopContext.increaseCustomerBalance(voucher.physicalSelfBalance);
				    				ctxs.shopContext.reloadShopUser();
			    				}
			    				else {
					    			ctxs.shopContext.setOperationStatusMessage(true, 'error', voucherContainer.code + " - " + voucherContainer.description);				    			
			    				}
			    			}
			    			else{
			    				ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error.');
			    			}		    			
			    		},
			    		
			    		error : (errorData) => {
			    			ctxs.shopContext.setFree();
			    			ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error.');
			    		}	
			       });
					
				}
			}
			const configuration = getConfiguration();
			const askForPaper = configuration.rs && configuration.rs.cfp && window.XSocket;
			if(!askForPaper){
				action();
			}
			else{
				ctxs.shopContext.setBusy();
				window.XSocket.askForPaper('GENERATE_PHYSICAL_REST_VOUCHER', (data) => {
					if(data.body === 'OK'){
						selfContext.setPaperCaseEmpty(false);
						ctxs.shopContext.setFree();
						action();		  
					}
					else {
						selfContext.setPaperCaseEmpty(true, data.body);
						ctxs.shopContext.setFree();
					}
			    });
			}
		},
		
		generateRechargeVoucher : function(amount){
			function action(){
				if(ctxs.shopContext.operator && ctxs.shopContext.operator.logged && !ctxs.shopContext.busy){
					ctxs.shopContext.setBusy();
					const url = getConfiguration().api['shop.generateRechargeVoucher'];
		  			const params = {
						systemCode : systemCode,
						lingua: xs_languageCode,
						hash: '',
						sessionToken : ctxs.shopContext.operator.sessionToken,
						amount : amount
	    			}		  			
			    	$.ajax({
			    		type: "POST",
			    		url : url,
			    		data: params,
			    		async : true,
			    		success : (data) => {
			    			ctxs.shopContext.setFree();
			    			if(data != null){
			    				const voucherContainer = JSON.parse(data);
			    				if(voucherContainer.code == 0){
				    				const voucher = voucherContainer.object;
				    				voucher.idTag = ctxs.shopContext.operator.idTag;
				    				voucher.shopId = ctxs.shopContext.operator.shopId;
				    				shopReceiptPrinterContext.printRechargeVoucherReceipt(voucher, false);
				    				ctxs.shopContext.increaseCustomerBalance(voucher.amn);
				    				ctxs.shopContext.reloadShopUser();
			    				}
			    				else {
					    			ctxs.shopContext.setOperationStatusMessage(true, 'error', voucherContainer.code + " - " + voucherContainer.description);				    			
			    				}
			    			}
			    			else{
			    				ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error.');
			    			}		    			
			    		},
			    		
			    		error : (errorData) => {
			    			ctxs.shopContext.setFree();
			    			ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error.');
			    		}	
			       });
					
				}
			}
			const configuration = getConfiguration();
			const askForPaper = configuration.rs && configuration.rs.cfp && window.XSocket;
			if(!askForPaper){
				action();
			}
			else{
				ctxs.shopContext.setBusy();
				window.XSocket.askForPaper('RECHARGE_VOUCHER', (data) => {
					if(data.body === 'OK'){
						selfContext.setPaperCaseEmpty(false);
						ctxs.shopContext.setFree();
						action();		  
					}
					else {
						selfContext.setPaperCaseEmpty(true, data.body);
						ctxs.shopContext.setFree();
					}
			    });
			}
		},
		
		payPhysicalSelfVoucher : function(voucherId){
			function action(){
				if(ctxs.shopContext.operator && ctxs.shopContext.operator.logged && !ctxs.shopContext.busy){
					ctxs.shopContext.setBusy();
					const url = getConfiguration().api['shop.payPhysicalSelfVoucher'];
		  			const params = {
						systemCode : systemCode,
						lingua: xs_languageCode,
						hash: '',
						sessionToken : ctxs.shopContext.operator.sessionToken,
						voucherId : voucherId
	    			}		  			
			    	$.ajax({
			    		type: "POST",
			    		url : url,
			    		data: params,
			    		async : true,
			    		success : (data) => {
			    			ctxs.shopContext.setFree();
			    			if(data != null){
			    				const paymentContainer = JSON.parse(data);
			    				if(paymentContainer.code == 0){
				    				const paymentResult = paymentContainer.object;
				    				// print receipt
				    				ctxs.shopContext.decreaseCustomerBalance(paymentResult.amount);
			    					ctxs.shopContext.setTerminalBalance(paymentResult.terminalBalance);
				    				paymentResult.showOperatorName = !ctxs.shopContext.isFunctionalityAllowed(window.retailFunctions['HIDE_OPERATOR_ON_RECEIPT']);
				    				paymentResult.showTerminalBalance = !ctxs.shopContext.isFunctionalityAllowed(window.retailFunctions['HIDE_CASH_BALANCE_ON_RECEIPT']);
				    				shopReceiptPrinterContext.printPhysicalRestVoucherPaymentReceipt(paymentResult, false);
				    				ctxs.shopContext.reloadShopUser();
			    				}
			    				else {
					    			ctxs.shopContext.setOperationStatusMessage(true, 'error', paymentContainer.code + " - " + paymentContainer.description);				    			
			    				}
			    			}
			    			else{
			    				ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error.');
			    			}		    			
			    		},
			    		
			    		error : (errorData) => {
			    			ctxs.shopContext.setFree();
			    			ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error.');
			    		}	
			       });
					
				}
			}
			
			const configuration = getConfiguration();
			const askForPaper = configuration.rs && configuration.rs.cfp && window.XSocket;
			if(!askForPaper){
				action();
			}
			else{
				ctxs.shopContext.setBusy();
				window.XSocket.askForPaper('PAY_PHYSICAL_SELF_VOUCHER', (data) => {
					if(data.body === 'OK'){
						selfContext.setPaperCaseEmpty(false);
						ctxs.shopContext.setFree();
						action();		  
					}
					else {
						selfContext.setPaperCaseEmpty(true, data.body);
						ctxs.shopContext.setFree();
					}
			    });
			}
		},
		
		payScratchCard : function(scratchCode, secretWord, pinCode, successCallback){
			function action(){
				if(ctxs.shopContext.operator && ctxs.shopContext.operator.logged && !ctxs.shopContext.busy){
					ctxs.shopContext.setBusy();
					const url = getConfiguration().api['shop.payScratchCard'];
		  			const params = {
						systemCode : systemCode,
						lingua: xs_languageCode,
						hash: '',
						sessionToken : ctxs.shopContext.operator.sessionToken,
						scratchCode,
						secretWord,
						pinCode
	    			}		  			
			    	$.ajax({
			    		type: "POST",
			    		url : url,
			    		data: params,
			    		async : true,
			    		success : (data) => {
			    			ctxs.shopContext.setFree();
			    			if(data != null){
			    				const paymentContainer = JSON.parse(data);
			    				if(paymentContainer.code == 0){
			    					if(successCallback){
			    						successCallback(paymentContainer);
			    					}
				    				const paymentResult = paymentContainer.object;
				    				// print receipt
				    				ctxs.shopContext.decreaseCustomerBalance(paymentResult.amount);
			    					ctxs.shopContext.setTerminalBalance(paymentResult.terminalBalance);
				    				paymentResult.showOperatorName = !ctxs.shopContext.isFunctionalityAllowed(window.retailFunctions['HIDE_OPERATOR_ON_RECEIPT']);
				    				paymentResult.showTerminalBalance = !ctxs.shopContext.isFunctionalityAllowed(window.retailFunctions['HIDE_CASH_BALANCE_ON_RECEIPT']);
				    				shopReceiptPrinterContext.printScratchCardPaymentReceipt(paymentResult, false);
				    				ctxs.shopContext.reloadShopUser();
			    				}
			    				else {
					    			ctxs.shopContext.setOperationStatusMessage(true, 'error', paymentContainer.code + " - " + paymentContainer.description);				    			
			    				}
			    			}
			    			else{
			    				ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error.');
			    			}		    			
			    		},
			    		
			    		error : (errorData) => {
			    			ctxs.shopContext.setFree();
			    			ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error.');
			    		}	
			       });
					
				}
			}
			
			const configuration = getConfiguration();
			const askForPaper = configuration.rs && configuration.rs.cfp && window.XSocket;
			if(!askForPaper){
				action();
			}
			else{
				ctxs.shopContext.setBusy();
				window.XSocket.askForPaper('PAY_PHYSICAL_SELF_VOUCHER', (data) => {
					if(data.body === 'OK'){
						selfContext.setPaperCaseEmpty(false);
						ctxs.shopContext.setFree();
						action();		  
					}
					else {
						selfContext.setPaperCaseEmpty(true, data.body);
						ctxs.shopContext.setFree();
					}
			    });
			}
		},
		accountRecharge : function(accountNumber, amount, userNickname, promoCode, pinCode, successCallback){

			function action(){
				if(ctxs.shopContext.operator && ctxs.shopContext.operator.logged && !ctxs.shopContext.busy){
					ctxs.shopContext.setBusy();
					const url = getConfiguration().api['shop.accountRecharge'];
					const amountCent = getAmountInCent(normalizeNumber(amount), conf.cs.m);
					if(amountCent == 0){
						return;
					}
		  			const params = {
						systemCode : systemCode,
						lingua: xs_languageCode,
						hash: '',
						sessionToken : ctxs.shopContext.operator.sessionToken,
						accountNumber,
						amount : amountCent,
						userNickname,
						promoCode,
						pinCode
	    			}		  			
			    	$.ajax({
			    		type: "POST",
			    		url : url,
			    		data: params,
			    		async : true,
			    		success : (data) => {
			    			ctxs.shopContext.setFree();
			    			if(data != null){
			    				const paymentContainer = JSON.parse(data);
			    				if(paymentContainer.code == 0){
			    					if(successCallback){
			    						successCallback(paymentContainer);
			    					}
				    				const paymentResult = paymentContainer.object;
				    				// print receipt
				    				ctxs.shopContext.decreaseCustomerBalance(paymentResult.amount);
			    					ctxs.shopContext.setTerminalBalance(paymentResult.terminalBalance);
			    					paymentResult.accountNumber = accountNumber;
				    				paymentResult.showOperatorName = !ctxs.shopContext.isFunctionalityAllowed(window.retailFunctions['HIDE_OPERATOR_ON_RECEIPT']);
				    				paymentResult.showTerminalBalance = !ctxs.shopContext.isFunctionalityAllowed(window.retailFunctions['HIDE_CASH_BALANCE_ON_RECEIPT']);
				    				shopReceiptPrinterContext.printAccountRechargeReceipt(paymentResult, false);
				    				ctxs.shopContext.reloadShopUser();
			    				}
			    				else {
					    			ctxs.shopContext.setOperationStatusMessage(true, 'error', paymentContainer.code + " - " + paymentContainer.description);				    			
			    				}
			    			}
			    			else{
			    				ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error.');
			    			}		    			
			    		},
			    		
			    		error : (errorData) => {
			    			ctxs.shopContext.setFree();
			    			ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error.');
			    		}	
			       });
					
				}
			}
			
			const configuration = getConfiguration();
			const askForPaper = configuration.rs && configuration.rs.cfp && window.XSocket;
			if(!askForPaper){
				action();
			}
			else{
				ctxs.shopContext.setBusy();
				window.XSocket.askForPaper('ACCOUNT_RECHARGE', (data) => {
					if(data.body === 'OK'){
						selfContext.setPaperCaseEmpty(false);
						ctxs.shopContext.setFree();
						action();		  
					}
					else {
						selfContext.setPaperCaseEmpty(true, data.body);
						ctxs.shopContext.setFree();
					}
			    });
			}
		},

		accountRechargePhysicalSelf : function(accountId,amount,sessionTokenLoggedPvr,successCallback){
			if(ctxs.shopContext.busy){
				// retry in 100 ms
				setTimeout(() => {
					ctxs.shopContext.accountRechargePhysicalSelf();
				}, 100);
				return;
			}
			if(ctxs.shopContext.selfCashier.physicalSelfBalance == 0){
				return;
			}
			function action(){
				if(ctxs.shopContext.selfCashier && ctxs.shopContext.selfCashier.logged && !ctxs.shopContext.busy){
					ctxs.shopContext.setBusy();
					const url = getConfiguration().api['shop.accountRechargePhysicalSelf'];
					const params = {
						systemCode : systemCode,
						lingua: xs_languageCode,
						hash: '',
						sessionToken : ctxs.shopContext?.selfCashier?.sessionToken,
						sessionTokenLoggedPvr: sessionTokenLoggedPvr,
						idContoPvr: selfContext?.idContoLinkedPvr,
						idTag: selfContext?.idTag,
						pvend: ctxs.shopContext?.selfCashier?.pvend,
						accountId:accountId,
						amount:amount
	    			}
					const frontendTransactionId = generateFrontendTransactionId(ctxs.shopContext.selfCashier, ACCOUNT_RECHARGE_PHYSICAL_SELF_RETRY); 
					if(frontendTransactionId){
						saveFrontendTransactionId(frontendTransactionId);
						params.frontendTransactionId = frontendTransactionId;
					}
			    	$.ajax({
			    		type: "POST",
			    		url : url,
			    		data: params,
			    		async : true,
			    		success : (data) => {
			    			ctxs.shopContext.setFree();
							removeFrontendTransactionId();
			    			if(data != null){
			    				const rechargeContainer = JSON.parse(data);
			    				if(rechargeContainer.code == 0){
									const recharge = rechargeContainer.object;
									if(recharge?.selfCashier && !recharge.selfCashier.cn) {
										const shopUser = ctxs.shopContext.getShopUser();
										try {
											const cnPvend = shopUser && shopUser.servicesMap? shopUser.servicesMap['SPORT'] : null;
											if(cnPvend){
												recharge.selfCashier.cn = cnPvend.split('/')[0];
											}else{
												recharge.selfCashier.cn =  shopUser?.cn;
											}
										}catch(err) {
											recharge.selfCashier.cn =  shopUser?.cn;
											console.error(err);
										}
									}
									if(successCallback) {
										successCallback(recharge);
									}
				    				shopReceiptPrinterContext.printAccountRechargeReceipt(recharge, false);
				    				// redo login to be sure that the user is correctly binded with the database
				    				ctxs.shopContext.setShopUser({logged : false, operator : false, selfCashier : true});
				    				ctxs.shopContext.loginPhysicalSelf();
			    				}
			    				else {
					    			selfContext.freezeAll(rechargeContainer.description, rechargeContainer.code);
					    			setTimeout(() => {
					    				selfContext.unfreezeAll();
					    			}, 3000);
					    			
			    				}
			    			}
			    			else{
			    				selfContext.freezeAll("Errore comunicazione centro servizi");
			    			}		    			
			    		},
			    		
			    		error : (errorData, textStatus, errorThrown) => {
							console.error("Error in calling accountRechargePhysicalSelf "+textStatus+" "+errorThrown);
							console.error(errorData);
							ctxs.shopContext.setFree();
							ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error.');
							selfContext.freezeAll("Errore "+getLabel('header.account_recharge'));
							setTimeout(() => {
								selfContext.unfreezeAll();
							}, 3000);
			    		}	
			       });	
				}
			}
			const configuration = getConfiguration();
			const askForPaper = configuration.rs && configuration.rs.cfp && window.XSocket;
			if(!askForPaper){
				action();
			}
			else{
				ctxs.shopContext.setBusy();
				window.XSocket.askForPaper('ACCOUNT_RECHARGE_RECEIPT', (data) => {
					if(data.body === 'OK'){
						selfContext.setPaperCaseEmpty(false);
						ctxs.shopContext.setFree();
						action();		  
					}
					else {
						ctxs.shopContext.setFree();
						selfContext.setPaperCaseEmpty(true, data.body);
					}
			    });
			}
			
		},

		getAccountDetails : function(accountNumber, successCallback){
			if(ctxs.shopContext.operator && ctxs.shopContext.operator.logged && !ctxs.shopContext.busy){
				ctxs.shopContext.setBusy();
				const url = getConfiguration().api['shop.getAccountDetails'];
				  const params = {
					systemCode : systemCode,
					lingua: xs_languageCode,
					hash: '',
					sessionToken : ctxs.shopContext.operator.sessionToken,
					accountNumber
				}		  			
				$.ajax({
					type: "POST",
					url : url,
					data: params,
					async : true,
					success : (data) => {
						ctxs.shopContext.setFree();
						if(data != null){
							const accountDetailsContainer = JSON.parse(data);
							if(accountDetailsContainer.code == 0){
								if(successCallback){
									successCallback(accountDetailsContainer);
								}
							}
							else {
								ctxs.shopContext.setOperationStatusMessage(true, 'error', accountDetailsContainer.code + " - " + accountDetailsContainer.description);				    			
							}
						}
						else{
							ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error.');
						}		    			
					},
					
					error : (errorData) => {
						ctxs.shopContext.setFree();
						ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error.');
					}	
			   });
				
			}
		},
		payThirdPartyVoucher : function(voucherId){
			function action(){
				if(ctxs.shopContext.operator && ctxs.shopContext.operator.logged && !ctxs.shopContext.busy){
					ctxs.shopContext.setBusy();
					const url = getConfiguration().api['shop.payThirdPartyVoucher'];
		  			const params = {
						systemCode : systemCode,
						lingua: xs_languageCode,
						hash: '',
						sessionToken : ctxs.shopContext.operator.sessionToken,
						voucherId : voucherId
	    			}		  			
			    	$.ajax({
			    		type: "POST",
			    		url : url,
			    		data: params,
			    		async : true,
			    		success : (data) => {
			    			ctxs.shopContext.setFree();
			    			if(data != null){
			    				const paymentContainer = JSON.parse(data);
			    				if(paymentContainer.code == 0){
				    				const paymentResult = paymentContainer.object;
				    				// print receipt
				    				ctxs.shopContext.decreaseCustomerBalance(paymentResult.amount);
			    					ctxs.shopContext.setTerminalBalance(paymentResult.terminalBalance);
				    				paymentResult.showOperatorName = !ctxs.shopContext.isFunctionalityAllowed(window.retailFunctions['HIDE_OPERATOR_ON_RECEIPT']);
				    				paymentResult.showTerminalBalance = !ctxs.shopContext.isFunctionalityAllowed(window.retailFunctions['HIDE_CASH_BALANCE_ON_RECEIPT']);
				    				shopReceiptPrinterContext.printThirdPartyVoucherPaymentReceipt(paymentResult, false);
				    				ctxs.shopContext.reloadShopUser();
			    				}
			    				else {
					    			ctxs.shopContext.setOperationStatusMessage(true, 'error', paymentContainer.code + " - " + paymentContainer.description);				    			
			    				}
			    			}
			    			else{
			    				ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error.');
			    			}		    			
			    		},
			    		
			    		error : (errorData) => {
			    			ctxs.shopContext.setFree();
			    			ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error.');
			    		}	
			       });
					
				}
			}
			
			const configuration = getConfiguration();
			const askForPaper = configuration.rs && configuration.rs.cfp && window.XSocket;
			if(!askForPaper){
				action();
			}
			else{
				ctxs.shopContext.setBusy();
				window.XSocket.askForPaper('USE_VOUCHER_SELF_BY_THIRD_PARTY', (data) => {
					if(data.body === 'OK'){
						selfContext.setPaperCaseEmpty(false);
						ctxs.shopContext.setFree();
						action();		  
					}
					else {
						selfContext.setPaperCaseEmpty(true, data.body);
						ctxs.shopContext.setFree();
					}
			    });
			}
		},
		generateAndPayPhySeRestVoucherByOperator : function(selfIdTag, successCallback){
			
			function action () {
				if(ctxs.shopContext.operator && ctxs.shopContext.operator.logged && !ctxs.shopContext.busy){
						const conf = getConfiguration();
						const retailSettings = conf.rs;
						const oldSelfList = ctxs.shopContext.selfListContainer.data;
						ctxs.shopContext.setSelfListContainer({isLoading : true, isError: false, data : oldSelfList});
						ctxs.shopContext.setBusy();
						const url = conf.api['shop.generateAndPayPhySeRestVoucherByOperator'];
						const params = {
							systemCode : systemCode,
							lingua: xs_languageCode,
							hash: '',
							sessionToken : ctxs.shopContext.operator.sessionToken,
							idTag: selfIdTag
						}		  			
						$.ajax({
							type: "POST",
							url : url,
							data: params,
							async : true,
							success : (data) => {
								ctxs.shopContext.setFree();
								if(data != null){
									const payedVoucherContainer = JSON.parse(data);
									if(payedVoucherContainer.code == 0){
										const paymentResult = payedVoucherContainer.object;
										// print receipt
										if(retailSettings.prse){
											ctxs.shopContext.setTerminalBalance(paymentResult.terminalBalance);
											paymentResult.showOperatorName = !ctxs.shopContext.isFunctionalityAllowed(window.retailFunctions['HIDE_OPERATOR_ON_RECEIPT']);
											paymentResult.showTerminalBalance = !ctxs.shopContext.isFunctionalityAllowed(window.retailFunctions['HIDE_CASH_BALANCE_ON_RECEIPT']);
											shopReceiptPrinterContext.printPhysicalRestVoucherPaymentReceipt(paymentResult, false);
										}
										ctxs.shopContext.setOperationStatusMessage(true, 'success', getLabel('general.success'));				    			
										ctxs.shopContext.reloadShopUser();

										if(successCallback) {
											successCallback();
										}
									}
									else {
										ctxs.shopContext.setOperationStatusMessage(true, 'error', payedVoucherContainer.code + " - " + payedVoucherContainer.description);				    			
									}
								}
								else{
									ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error.');
								}		    			
							},
							
							error : (errorData) => {
								ctxs.shopContext.setFree();
								ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error.');
							}	
					});		
				}
			}

			const configuration = getConfiguration();
			const askForPaper = configuration.rs && configuration.rs.cfp && window.XSocket && configuration.rs.prse;
			if(!askForPaper){
				action();
			}
			else{
				ctxs.shopContext.setBusy();
				window.XSocket.askForPaper('PAY_PHYSICAL_SELF_VOUCHER', (data) => {
					if(data.body === 'OK'){
						selfContext.setPaperCaseEmpty(false);
						ctxs.shopContext.setFree();
						action();		  
					}
					else {
						selfContext.setPaperCaseEmpty(true, data.body);
						ctxs.shopContext.setFree();
					}
			    });
			}
		},
		
		refillSelfBalance : function(selfIdTag, amount){
			if(ctxs.shopContext.operator && ctxs.shopContext.operator.logged && !ctxs.shopContext.busy){
					const oldSelfList = ctxs.shopContext.selfListContainer.data;
					ctxs.shopContext.setSelfListContainer({isLoading : true, isError: false, data : oldSelfList});
					ctxs.shopContext.setBusy();
					const url = getConfiguration().api['shop.refillSelfBalance'];
		  			const params = {
						systemCode : systemCode,
						lingua: xs_languageCode,
						hash: '',
						sessionToken : ctxs.shopContext.operator.sessionToken,
						selfIdTag,
						amount
	    			}		  			
			    	$.ajax({
			    		type: "POST",
			    		url : url,
			    		data: params,
			    		async : true,
			    		success : (data) => {
			    			ctxs.shopContext.setFree();
			    			if(data != null){
			    				const resultContainer = JSON.parse(data);
			    				if(resultContainer.code == 0){
				    				const selfList = resultContainer.object;
				    				ctxs.shopContext.setSelfListContainer({isLoading:false, isError: false, data : selfList});
				    				ctxs.shopContext.reloadShopUser();
			    				}
			    				else {
			    					ctxs.shopContext.setSelfListContainer({isLoading : false, isError: false, data : oldSelfList});
					    			ctxs.shopContext.setOperationStatusMessage(true, 'error', resultContainer.code + " - " + resultContainer.description);				    			
			    				}
			    			}
			    			else{
			    				ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error.');
			    				ctxs.shopContext.setSelfListContainer({isLoading : false, isError: false, data : oldSelfList});
			    			}		    			
			    		},
			    		
			    		error : (errorData) => {
			    			ctxs.shopContext.setFree();
			    			ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error.');
			    			ctxs.shopContext.setSelfListContainer({isLoading : false, isError: false, data : oldSelfList});
			    		}	
			       });		
				}
		},
		
		generateTokenIsibet : function (callback){
			const shopUser = ctxs.shopContext.getShopUser();
			if(shopUser.logged && !ctxs.shopContext.busy){
				const url = getConfiguration().api['shop.generateTokenIsibet'];
	  			const params = {
						systemCode : systemCode,
						lingua: xs_languageCode,
						hash: '',
						sessionToken : shopUser.sessionToken
				}
	  			ctxs.shopContext.setBusy();
		    	$.ajax({
		    		type: "POST",
		    		url : url,
		    		data: params,
		    		async : true,
		    		success : (data) => {
		    			ctxs.shopContext.setFree();
		    			callback(data !== null? JSON.parse(data) : null);
		    		},
		    		error : (errorData) => {
		    			ctxs.shopContext.setFree();
		    			callback(null);
		    		}	
		       });			
			}
		},
		generateTokenMstbet : function (callback){
			const shopUser = ctxs.shopContext.getShopUser();
			if(shopUser.logged && !ctxs.shopContext.busy){
				const url = getConfiguration().api['shop.generateTokenMst'];
	  			const params = {
						systemCode : systemCode,
						lingua: xs_languageCode,
						hash: '',
						sessionToken : shopUser.sessionToken
				}
	  			ctxs.shopContext.setBusy();
		    	$.ajax({
		    		type: "POST",
		    		url : url,
		    		data: params,
		    		async : true,
		    		success : (data) => {
		    			ctxs.shopContext.setFree();
		    			callback(data !== null? JSON.parse(data) : null);
		    		},
		    		error : (errorData) => {
		    			ctxs.shopContext.setFree();
		    			callback(null);
		    		}	
		       });			
			}
		},
		cashierPickingReport : function(){
				const shopUser = ctxs.shopContext.getShopUser();
				if(shopUser && shopUser.selfCashier && shopUser.logged){
					const url = getConfiguration().api['shop.cashierPickingReport'];
		  			const params = {
    					systemCode : systemCode,
    					lingua: xs_languageCode,
    					hash: '',
    					idFsc : shopUser.idFsc,
    					cn : shopUser.cn,
						pvend:shopUser.pvend,
						idTag:shopUser.idTag
	    			}		  			
			    	$.ajax({
			    		type: "POST",
			    		url : url,
			    		data: params,
			    		async : true,
			    		success : (data) => {
			    			if(data){
								//selfContext.setPickingReportData(JSON.parse(data));
								ctxs.selfContext?.setPickingReportData(JSON.parse(data));
			    			}
			    			else{
			    				selfContext.freezeAll("Errore comunicazione centro servizi");
			    			}
			    		},
			    		error : (errorData) => {
			    			selfContext.freezeAll("Errore comunicazione centro servizi");
			    		}	
			       });
					
				}
				else{
					selfContext.freezeAll("TERMINALE NON LOGGATO. CONTATTA UN'OPERATORE.");
				}
		},
		cashierPickingTransaction: function(callback){
			function action(){
				const shopUser = ctxs.shopContext.getShopUser();
				try {
					const pickingData = {'coins':[],'bills':[]};
					let totalAmount = 0;

					(/*selfContext.pickingReportData*/ctxs.selfContext?.pickingReportData)?.forEach(p=>{
						if(isCoinAmount(p.importo)){
							pickingData.coins.push(p);
						}
						else{
							pickingData.bills.push(p);
						}
						totalAmount+=p.totImporto;
					})
				
					if(totalAmount > 0){
						const url = getConfiguration().api['shop.cashierPickingTransaction'];
						const params = {
						systemCode : systemCode,
						lingua: xs_languageCode,
						hash: '',
						idFsc : shopUser.idFsc,
						cn : shopUser.cn,
						pvend:shopUser.pvend,
						idTag:shopUser.idTag,
						idTrans:0,
						amount:totalAmount,
						balance:0

						}
						$.ajax({
							type: "POST",
							url : url,
							data: params,
							async : true,
							success : (data) => {
								if(data == 0){
									shopReceiptPrinterContext.printPickingReceipt({'shopData':shopUser,'pickingData':pickingData}, false);
								}
								else{
									selfContext.freezeAll("Operazione non effettuata. Contattare l’assistenza clienti");
								}
								callback();

							},
							error : (errorData) => {
								selfContext.freezeAll("Operazione non effettuata. Contattare l’assistenza clienti");
								callback();

							}	
					});
				  }		  	
				}catch(err){
					console.error(err);
					callback();
					selfContext.freezeAll("Operazione non effettuata. Contattare l’assistenza clienti");
				}
			}
			
			const configuration = getConfiguration();
			const askForPaper = configuration.rs && configuration.rs.cfp && window.XSocket;
			if(!askForPaper){
				action();
			}
			else{
				ctxs.shopContext.setBusy();
				window.XSocket.askForPaper('CASH_PICKING_REPORT', (data) => {
					if(data.body === 'OK'){
						selfContext.setPaperCaseEmpty(false);
						ctxs.shopContext.setFree();
						action();		  
					}
					else {
						selfContext.setPaperCaseEmpty(true, data.body);
						ctxs.shopContext.setFree();
					}
			    });
			}
		},
		cashierTransactionsLog : function(){
			function action(){
				const shopUser = ctxs.shopContext.getShopUser();
				if(shopUser && shopUser.selfCashier && shopUser.logged){
					const url = getConfiguration().api['shop.cashierTransactionsLog'];
					  const params = {
						systemCode : systemCode,
						lingua: xs_languageCode,
						hash: '',
						idFsc : shopUser.idFsc,
						cn : shopUser.cn,
						pvend:shopUser.pvend,
						idTag:shopUser.idTag
					}		  			
					$.ajax({
						type: "POST",
						url : url,
						data: params,
						async : true,
						success : (data) => {
							if(data){
								shopReceiptPrinterContext.printTransactionsLog(JSON.parse(data), false);
							}
							else{
								selfContext.freezeAll("Errore comunicazione centro servizi");
							}
						},
						error : (errorData) => {
							selfContext.freezeAll("Errore comunicazione centro servizi");
						}	
				   });
					
				}
				else{
					selfContext.freezeAll("TERMINALE NON LOGGATO. CONTATTA UN'OPERATORE.");
				}
			}
			const configuration = getConfiguration();
			const askForPaper = configuration.rs && configuration.rs.cfp && window.XSocket;
			if(!askForPaper){
				action();
			}
			else{
				ctxs.shopContext.setBusy();
				window.XSocket.askForPaper('CASHIER_TRANSACTION_LOGS', (data) => {
					if(data.body === 'OK'){
						selfContext.setPaperCaseEmpty(false);
						ctxs.shopContext.setFree();
						action();		  
					}
					else {
						selfContext.setPaperCaseEmpty(true, data.body);
						ctxs.shopContext.setFree();
					}
			    });
			}
	},

	physicalSelfAccountRechargeReport : function(dateFrom,dateTo,successCallback,errorCallback){
		const shopUser = ctxs.shopContext.getShopUser();
		if(shopUser && shopUser.selfCashier && shopUser.logged){
			const url = getConfiguration().api['shop.physicalSelfAccountRechargeReport'];
				const params = {
				systemCode : systemCode,
				lingua: xs_languageCode,
				hash: '',
				pvend:shopUser.pvend,
				idTag:shopUser.idTag,
				dateFrom,
				dateTo
			}		  			
			$.ajax({
				type: "POST",
				url : url,
				data: params,
				async : true,
				success : (data) => {
					if(data){
						if(successCallback) {
							const parsedData = JSON.parse(data);
							parsedData.pvend = shopUser.pvend;
							parsedData.idTag = shopUser.idTag;
							parsedData.dateFrom = dateFrom;
							parsedData.dateTo = dateTo;
							successCallback(parsedData);
						}
					}
					else{
						if(errorCallback) {
							errorCallback()
						}
						selfContext.freezeAll("Errore comunicazione centro servizi");
					}
				},
				error : (errorData) => {
					if(errorCallback) {
						errorCallback()
					}
					selfContext.freezeAll("Errore comunicazione centro servizi");
				}	
			});
			
		}
		else{
			selfContext.freezeAll("TERMINALE NON LOGGATO. CONTATTA UN'OPERATORE.");
		}
	},

	printPhysicalSelfAccountRechargeReport(reportData) {
		const configuration = getConfiguration();
        const askForPaper = configuration.rs && configuration.rs.cfp && window.XSocket;
        if(!askForPaper){
            shopReceiptPrinterContext.printPhysicalSelfAccountRechargeReport(reportData, false);
        }
        else{
            ctxs.shopContext.setBusy();
            window.XSocket.askForPaper('PHYSICAL_SELF_ACCOUNT_RECHARGE_REPORT', (data) => {
                if(data.body === 'OK'){
                    selfContext.setPaperCaseEmpty(false);
                    ctxs.shopContext.setFree();
                    shopReceiptPrinterContext.printPhysicalSelfAccountRechargeReport(reportData, false);	  
                }
                else {
                    selfContext.setPaperCaseEmpty(true, data.body);
                    ctxs.shopContext.setFree();
                }
            });
        }
	},

	isVirtualChannelEnabled: function(codePiatt,channel){
        const operator = ctxs.shopContext.getShopUser();
		if (!operator) {
			return true;
		}

        if (operator.virtualChannels == null || Object.keys(operator.virtualChannels).length === 0) {
            return true;
        }

		return operator.virtualChannels[codePiatt]?.includes(channel) ?? false;
	},

	isHideOperatorOnReceipt: function(){
		return ctxs.shopContext.isFunctionalityAllowed(window.retailFunctions['HIDE_OPERATOR_ON_RECEIPT'])
	},
	
	showCfPopup : function (confirmFunction){
		if(window.popupGetCodiceFiscale){
			// old XSport Terminal
			window.popupGetCodiceFiscale((cf) =>{
				ctxs.shopContext.setCfForPurchase(cf + "");
				confirmFunction();
			});
		}
		else {
			if(ctxs.shopContext.isSlaveOfAnotherShopConf){
				// trigger the main one in the main shopConf
				const getCFFunction = (cf) => {
					ctxs.shopContext.setCfForPurchase(cf + "");
					confirmFunction();
				}
				window.shopApi.showCfPopup(getCFFunction);
			}
			else {
				if(selfContext.setShowCFModal){
					const getCFFunction = (cf) => {
						ctxs.shopContext.setCfForPurchase(cf + "");
						// passing the cf to ensure this flow: the confirm function comes from the slave ShopConf
						confirmFunction(cf);
					}
					selfContext.setShowCFModal(getCFFunction);
				}
			}
			
		}
	},
	
	reserveDepositForFinalUser : function(ticketId, documentId, protocolCode, amount, externalPsvPlatform){
		function action(){
				ctxs.shopContext.hideOperationStatusMessage();
				if(ctxs.shopContext.operator && ctxs.shopContext.operator.logged){
					ctxs.shopContext.setBusy();
		  			const params = {
						systemCode : systemCode,
						lingua: xs_languageCode,
						hash: '',
						sessionToken : ctxs.shopContext.operator.sessionToken,
						ticketId,
						documentId,
						protocolCode,
						amount,
						externalPsvPlatform
	    			};
					$.ajax({
			    		type: "POST",
			    		url : getConfiguration().api['shop.reserveDepositForFinalUser'],
			    		data: params,
			    		async : true,
			    		success : (data) => {
			    			ctxs.shopContext.setFree();
			    			if(data != null){
			    				const result = JSON.parse(data);
			    				if(result.code == 0){
			    					const data = {
			    						operator : ctxs.shopContext.operator,
			    						ticketId,
			    						documentId,
			    						amount
			    					};
				    				shopReceiptPrinterContext.printReserveDepositForFinalUserReceipt(data);
			    				}
			    				else {
			    					ctxs.shopContext.setOperationStatusMessage(true, 'error', result.code + " - " + result.description);
			    					if(result.code == -5307){
			    						window.removeLoggedParametersOnLS();
			    						ctxs.shopContext.setShopUser({logged : false, operator : true, selfCashier : false});
			    						setTimeout(() => {
			    							window.location.reload();
			    						}, 1000);
						    			
			    					}
			    				}
			    			}
			    			else{
			    				ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error.');
			    			}
			    		},
			    		error : (errorData) => {
			    			ctxs.shopContext.setFree();
			    			ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error.');
			    		}	
			       });	
				}
			}
		const configuration = getConfiguration();
		const askForPaper = configuration.rs && configuration.rs.cfp && window.XSocket;
		if(!askForPaper){
			action();
		}
		else{
			ctxs.shopContext.setBusy();
			window.XSocket.askForPaper('RESERVE_DEPOSIT_FOR_FINAL_USER', (data) => {
				if(data.body === 'OK'){
					selfContext.setPaperCaseEmpty(false);
					ctxs.shopContext.setFree();
					action();		  
				}
				else {
					selfContext.setPaperCaseEmpty(true, data.body);
					ctxs.shopContext.setFree();
				}
		    });
		}
	},
	withdrawRequest : function(amount, iban, causale, owner, successCallback){
	if(ctxs.shopContext.busy){
		return;
	}
	if(!ctxs.shopContext.isFunctionalityAllowed(window.retailFunctions['REAL_WITHDRAW_REQUEST'])){
		return;
	}
	
	
	function action(){
		ctxs.shopContext.hideOperationStatusMessage();
		if(ctxs.shopContext.operator && ctxs.shopContext.operator.logged){
			ctxs.shopContext.setBusy();
			const amountCent = getAmountInCent(normalizeNumber(amount), conf.cs.m);
			if(amountCent == 0){
				return;
			}

  			const params = {
				systemCode : systemCode,
				lingua: xs_languageCode,
				hash: '',
				sessionToken : ctxs.shopContext.operator.sessionToken,
				amount : amountCent,
				iban,
				causale,
				owner
			};
			$.ajax({
	    		type: "POST",
	    		url : getConfiguration().api['shop.withdrawRequest'],
	    		data: params,
	    		async : true,
	    		success : (data) => {
	    			ctxs.shopContext.setFree();
	    			if(data != null){
	    				const result = JSON.parse(data);
	    				if(result.code == 0){
		    				result.operationAmount = amountCent;
		    				result.operator = ctxs.shopContext.operator;
		    				result.owner = owner;
		    				result.causale = causale;
		    				shopReceiptPrinterContext.printwithdrawRequestReceipt(result);
		    				if(successCallback){
		    					successCallback();
		    				}
	    				}
	    				else {
	    					ctxs.shopContext.setOperationStatusMessage(true, 'error', result.code + " - " + result.description);
	    					if(result.code == -5307){
	    						window.removeLoggedParametersOnLS();
	    						ctxs.shopContext.setShopUser({logged : false, operator : true, selfCashier : false});
	    						setTimeout(() => {
	    							window.location.reload();
	    						}, 1000);
				    			
	    					}
	    				}
	    			}
	    			else{
	    				ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error.');
	    			}
	    		},
	    		error : (errorData) => {
	    			ctxs.shopContext.setFree();
	    			ctxs.shopContext.setOperationStatusMessage(true, 'error', 'Generic Error.');
	    		}	
	       });	
		}
	}
	
	const configuration = getConfiguration();
	const askForPaper = configuration.rs && configuration.rs.cfp && window.XSocket;
	if(!askForPaper){
		action();
	}
	else{
		ctxs.shopContext.setBusy();
		window.XSocket.askForPaper('REAL_WITHDRAW_REQUEST', (data) => {
			if(data.body === 'OK'){
				selfContext.setPaperCaseEmpty(false);
				ctxs.shopContext.setFree();
				action();		  
			}
			else {
				ctxs.shopContext.setFree();
				selfContext.setPaperCaseEmpty(true, data.body);
			}
	    });
	}
	
}

	});

	
	/** [contexts stable references]
	 * if a React Context is used into a state object function (no matter if a callback, a function like "purchase" and so on)
	 * its pointed value is the "snapshotted" one taken during the function declaration. 
	 * F.E. if contextA = { a:1}, and I declare a  function into betslipContext (that after all is an useState) that
	 * will use that context, then the context value will be always {a:1} even if in the rest of the application has been
	 * updated. To solve this, we need to use a stable reference which keep always the brand new context value.
	 * BTW, this issue is not affecting the self reference, betslipContext is updated in its state, f.e. in purchase function
	 *   */
	const ctxs = useRef({}).current;
    ctxs.shopContext = shopContext;
	ctxs.selfContext = selfContext;

	useEffect(() => {
		if(shopContext.enabled){
			shopContext.initType();
			shopContext.buildSkinProperties();
			let unloggedCallback = null;
			if(selfContext.appDataCommitted && window.XSocket){
				window.XSocket.setHandlerForPushNotification(window.XSocket._BALANCE_OP.type, (data, socketCallback) => {
					const amount = parseInt(data.body);
					// load db to update this voucher
					shopContext.handleSelfCashierBalanceUpdate(amount, socketCallback);
				});
				
				window.XSocket.setHandlerForPushNotification(window.XSocket._VOUCHER_READ.type, (data, socketCallback) => {
					if(!selfContext.freezeAppMessage){
						const voucherId = data.body;
						// load db to update this voucher
						shopContext.handleVoucherRead(voucherId, socketCallback);
					}

				});

				/*window.XSocket.setHandlerForPushNotification(window.XSocket._TICKET_ID_READ.type, (data, socketCallback) => {
					if(!selfContext.freezeAppMessage){
						const ticketId = data.body;
						shopContext.handleShowCheckBet(ticketId, socketCallback);
					}

				});*/
				window.XSocket.setHandlerForPushNotification(window.XSocket._TICKET_ID_READ.type, (data, socketCallback) => {
						const ticketId = data.body;
						shopContext.handleTicketIdRead(ticketId, socketCallback);
				});
				
				// if it is a self, and it is not the "force" distribution				
				if(selfContext.clientType.indexOf('self') >= 0 && selfContext.deviceId.indexOf('default') < 0){
					// if unlogged, then login
					unloggedCallback = function (){
						shopContext.loginPhysicalSelf();
					}
					
				}
			}
			shopContext.reloadShopUser(unloggedCallback);

			if(selfContext.appDataCommitted && window.XSocket){
				if(shopContext.selfCashier && shopContext.selfCashier.logged){				
					// checking if there is a pending transaction in the storage
					const pendingTransactionData = getPendingFrontendTransactionId();
					if(pendingTransactionData && pendingTransactionData.type === GENERATE_REST_VOUCHER_RETRY){	
						shopContext.startRetryRestFailureCallback(pendingTransactionData.frontendTransactionId);
					}
				}
			}

			// exposing an API interface for the shop terminal distro. It must be done in the useEffect here,
			// to be sure that each function invokation is correctly binded with the React World!
			const shopApiSource = {
					
					testLoginOperator : function (username, password){
						ctxs.shopContext.loginOperator(username, password);
					},
					
					testLogoutOperator : function(){
						ctxs.shopContext.logoutOperator();
					},

					logoutOperator: function(callback){
						ctxs.shopContext.logoutOperator(callback);
					},
					
					reloadTicket : function(ticketId){
						window.reloadTicket(ticketId);
					},
					reloadLastTicket : function(){
						return ctxs.shopContext.reloadLastTicket();
					},
					printTicketCopy : function (ticketId){
						window.printTerminalCopy(ticketId);
					},
					
					printAgainReceipt : function (ticketId){
						window.reprintTerminalTicket(ticketId);
					},
					printTicketCashout : function(ticketId){
						window.printTicket(ticketId, false, true);
					},
					
					reloadShopUser : function (){
						ctxs.shopContext.reloadShopUser();
					},
					
					getBetFromAggregationFile : function(scomSogei, handicap){
						return getBetAggr(scomSogei, handicap);
					},
					getBetDescription : function(scomSogei, handicap){
						let bet = getBetAggr(scomSogei, handicap);
						if(bet == null && handicap != 0){
							bet = getBetAggr(scomSogei, 0);
						}
						if(bet != null){
							return getBetDesc(bet);
						}
						return null;
					},
					localizeTicketElement : function(element){
						let descrScomm = element.descrScomm;
						let descrEsito = element.descrEsito;

						// calcolo le descrizioni scommessa appoggiandomi a react
						let bet = window.shopApi.getBetFromAggregationFile(element.scom, element.handicap);
						if(bet == null && element.handicap != 0){
							bet = window.shopApi.getBetFromAggregationFile(element.scom,0);
						}
						if(bet != null){
							let calculatedBetDesc = getBetDesc(bet);
							descrScomm = calculatedBetDesc == null? descrScomm : calculatedBetDesc;
				 			for(let ko in bet.odds){
			    				if(bet.odds[ko].id == element.codEsito){
			    					descrEsito = bet.odds[ko].desc;
			    				}
			    			}
						}
						element.descrScomm = descrScomm;
						element.descrEsito = descrEsito;
					},
					showCfPopup : function(confirmFunction){
						ctxs.shopContext.showCfPopup(confirmFunction);	
					},
					getLiveDelayIncr : function(){
						if(typeof window.getConfAgenziaAgeLS === 'function'){
							const conf = window.getConfAgenziaAgeLS();
							if(conf != null){
								return conf.psqfLiveDelay == null? 0 : conf.psqfLiveDelay;
							}
						}
						return 0;
					},
					setDeviceFree : function (){
						ctxs.shopContext.setFree();
					},
					setDeviceBusy : function(){
						ctxs.shopContext.setBusy();
					},
					increaseCustomerBalance : function (amount){
						ctxs.shopContext.increaseCustomerBalance(amount);
					},
					decreaseCustomerBalance : function(amount){
						ctxs.shopContext.decreaseCustomerBalance(amount);
					},
					setTerminalBalance : function(amount){
						ctxs.shopContext.setTerminalBalance(amount);
					},
					increaseTerminalBalance : function(amount){
						ctxs.shopContext.increaseTerminalBalance(amount);
					},
					
					setCustomerBalance : function(amount){
						ctxs.shopContext.setCustomerBalance(amount);
					},
					isDeviceBusy : function(){
						return ctxs.shopContext.busy;
					},
					isDeviceFree : function(){
						return !ctxs.shopContext.busy;
					},
					removeMonitorMessage : function(){
						ctxs.shopContext.removeMonitorMessage();
					},
					showMonitorMessage : function(message, permanent){
						ctxs.shopContext.showMonitorMessage(message, permanent);
					},
					setCfForPurchase : function(cf){
						ctxs.shopContext.setCfForPurchase();
					},
					showSelectionVariationsModal : function (selections, message, confirmCallback){
						ctxs.shopContext.showSelectionVariationsModal(selections, message, confirmCallback);
					},
					isHookAllKeystrokesOnPurchaseEnabled() {
						return ctxs?.shopContext?.isHookAllKeystrokesOnPurchaseEnabled();
					}
				
			};	
			
		
			// exposing this api: if we are slave of another shopConf, then I wont replace the original one
			if(shopContext.isSlaveOfAnotherShopConf){
				window.shopApiSlave = shopApiSource;
			}
			else{
				window.shopApi = shopApiSource;
			}

			// gestione ippica isibet
			if(window.XSocket && props.selfContext && props.selfContext.appDataCommitted){
				function getReceiptObject(isibetTicketData){
					let amountWithCurrency = isibetTicketData.total + "";
					const conf = getConfiguration();
					if(amountWithCurrency.indexOf(' ') >= 0){
						const values = amountWithCurrency.split(' ');
						if(values.length === 2){
							amountWithCurrency = getCurrencySymbol(conf.cs.ct) + ' ' + values[1];
						}
					}
					return (
						{
							object:
							{
								amountLabel: isibetTicketData.agentLabel,
								amountWithCurrency: amountWithCurrency,
								dateTimeLabel: isibetTicketData.txDateTimeLabel,
								formattedTimestamp: isibetTicketData.txDateTime,
								terminalLabel: isibetTicketData.terminalLabel,
								idTag: isibetTicketData.terminal,
								operator: isibetTicketData.agent,
								operatorLabel: isibetTicketData.agentLabel
							},
							showOperatorName: !ctxs.shopContext.isHideOperatorOnReceipt()
						}
					)
				}

				window.XSocket.setHandlerForPushNotification(window.XSocket._PRINT_PAYMENT_HORSE_ISIBET.type, (data, socketCallback) => {
					let isibetTicketData = data.body;
					if(typeof isibetTicketData === 'string'){
						isibetTicketData = JSON.parse(isibetTicketData);
		}
					shopReceiptPrinterContext.printPaymentTicketReceipt(getReceiptObject(isibetTicketData));
					socketCallback && socketCallback();
				});
				
				window.XSocket.setHandlerForPushNotification(window.XSocket._PRINT_ANNULMENT_HORSE_ISIBET.type, (data, socketCallback) => {
					let isibetTicketData = data.body;
					if(typeof isibetTicketData === 'string'){
						isibetTicketData = JSON.parse(isibetTicketData);
					}
					shopReceiptPrinterContext.printCancelTicketReceipt(getReceiptObject(isibetTicketData));
					socketCallback && socketCallback();
				});
			}
			
		}
	}, [selfContext.appDataCommitted]);
	
	useEffect(() => {
		if(selfContext.deviceBusy !== undefined){
			if(selfContext.deviceBusy){
				shopContext.setBusy(true);
			}
			else{
				shopContext.setFree();
			}
		}
	}, [selfContext.deviceBusy]);
	
	useEffect(() => {
		const isExternalPsv = window.location.href.indexOf("external-virtual") > 0;
		const isHorsePage = window.location.href.indexOf("ippica") > 0;
		const isPscpPage =  window.location.href.indexOf("totocalcio") > 0;
		const isPurchaseHandledByExa = !isExternalPsv && !isHorsePage && !isPscpPage;
		
		if(ctxs.shopContext.operator?.logged &&
		   selfContext.protocolRendered && 
		   ctxs.shopContext.enabled && 
		   !ctxs.shopContext.busy &&
		   !isPurchaseHandledByExa){
			ctxs.shopContext.setTerminalBalancePolling(true);
		}
		else{
			ctxs.shopContext.setTerminalBalancePolling(false);
		}
	},[selfContext.protocolRendered, ctxs.shopContext.operator, ctxs.shopContext.busy])
	
	
	function getType(){
		let type = null;
		if(window.appConfig.SHOP_MODE){
			if(window.appConfig.TERMINAL_AGENCY){
				type = 'TERMINAL';
				
			}
			else if(window.appConfig.SELF_CASHIER){
				type = 'SELF-CASHIER';
			}
			else if(window.appConfig.SHOP_BOOKER){
				type = 'SHOP-BOOKER';
			}
		}
		return type;
	}
	
	function addBodyShadow(){
		$('.xshop-body').addClass('retailShadow');
		$('.xshop-body').addClass('pointerNone');
	}
	
	function removeBodyShadow(){
		$('.xshop-body').removeClass('retailShadow');
		$('.xshop-body').removeClass('pointerNone');
	}

	function payTicketBroadcastToSecondScreen(ticketId,payTicketResult) {
		const bc = new BroadcastChannel('second-screen-betslip');
        bc.postMessage({
            type: 'payTicketResult',
            payload: {
                payTicketResult: {ticketId,...payTicketResult}
            }
        });
        bc.close();
	}

	
    return (
        	<ShopContext.Provider value={shopContext}>
        	    {props.children}
        	</ShopContext.Provider>
    );
}

export default ShopConf;